// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T20:38:39.943Z
// Property: Cadence at Cates Creek (ID: 5656427712479232)
// Collections: 28 amenities, 3 floorplans (live), 29 photos, 81 POIs, 5 reviews, 5 virtual tours, 6 office hours, 17 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "5656427712479232",
  "property_external_id": "4939303",
  "property_zillow_url": "https://www.zillow.com/apartments/hillsborough-nc/ardmore-cates-creek/B6CHgG/",
  "property_apartments_url": "https://www.apartments.com/cadence-at-cates-creek-hillsborough-nc/mlm12yj",
  "property_google_business_url": "https://www.google.com/maps/place/Cadence+at+Cates+Creek/@36.0469093,-79.0941925,15z/data=!4m2!3m1!1s0x0:0x38b9f61ea3a6c780?sa=X&ved=2ahUKEwi2kLWL0O72AhX8j2oFHayzCMoQ_BJ6BAg4EAU",
  "property_linkedin_url": null,
  "property_hubspot_id": "8443932493",
  "property_crm_software": "Rent Dynamics",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "cadence-at-cates-creek",
  "property_name": "Cadence at Cates Creek",
  "property_website_url": "https://www.cadenceatcatescreek.com/",
  "property_domain": "https://www.cadenceatcatescreek.com/",
  "property_address": "100 Waterstone Park Cir",
  "property_full_address": "100 Waterstone Park Cir, Hillsborough, NC 27278",
  "property_address_1": "100 Waterstone Park Cir",
  "property_address_2": null,
  "property_address_city": "Hillsborough",
  "property_address_state": "NC",
  "property_address_zip_full": "27278-9879",
  "property_address_zip": "27278",
  "property_address_country": "US",
  "property_address_county": "Orange County",
  "property_neighborhood_address": "Greater Chapel Hill",
  "property_address_latitude": "36.0477977",
  "property_address_longitude": "-79.0940694",
  "property_email": "cadence@alapts.com",
  "property_phone": "(919) 245-8947",
  "property_call_tracking_phone": "984-252-4165",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>Modern comfort with Hillsborough character.</strong> Explore one, two, and three bedroom apartments with open layouts, granite countertops, wood-style flooring, and private outdoor space—then browse <a href=\"/floor-plans\">floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see Cadence at Cates Creek in person.</p>",
  "property_long_description": "<p><strong>Modern comfort with Hillsborough character.</strong> At Cadence at Cates Creek, you can settle into one, two, or three bedroom apartments near UNC Hospitals Hillsborough Campus, I-40, and the shops and restaurants of historic downtown Hillsborough. Inside, open-concept layouts pair granite countertops, stainless-steel-style appliances, designer cabinetry, wood-style flooring, 9-foot ceilings with crown molding, walk-in closets, and a private patio or Juliette balcony.</p><p>Beyond your front door, days can move from the <a href=\"/amenities\">resort-style pool</a> and 24-hour fitness center to the resident lounge, business center, outdoor fireplace, poolside grilling pavilion, pet park with wash station, and complimentary Starbucks coffee bar. When you want to explore, follow the Eno River along Hillsborough Riverwalk, or head to Weaver Street Market, Churton Street dining, Cates Creek Park, and Occoneechee Mountain State Natural Area. Browse <a href=\"/floor-plans\">1, 2 &amp; 3 bedroom floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see it in person.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019d02f0-0543-77e1-a5ee-25d8e8035cd9.webp",
  "property_featured_image_media": {
    "alt_text": "Open concept living room and kitchen with wood cabinets, stainless steel appliances, and a sectional sofa.",
    "public_id": "019d02f0-0543-77e1-a5ee-25d8e8035cd9",
    "storage_key": "property/5656427712479232/019d02f0-0543-77e1-a5ee-25d8e8035cd9.webp",
    "width": 1240,
    "height": 827
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "270",
  "property_year_built": "2016",
  "property_year_renovated": "2022",
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "93.33333333333333",
  "property_admin_fee": "250",
  "property_application_fee": "85",
  "property_fees_deposit_info": "Admin Fee: $250\nApplication Fee: $85\nApplication Approval Fee: Starting at $399\nNon-Refundable Pet Fee: $400 per pet\nMonthly Pet Rent: $30 per pet\nGarage Rent: Starting at $175",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "400",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $400 per pet, with a monthly pet rent of $30 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $400 per pet, with a monthly pet rent of $30 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://8821001.onlineleasing.realpage.com",
  "property_resident_portal_url": "https://cadence.loftliving.com/login",
  "property_apply_now_url": "https://8821001.onlineleasing.realpage.com",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019e4379-b9fc-7318-93c0-77558784c898.webp",
  "property_primary_logo_media": {
    "alt_text": "Cadence at Cates Creek logo",
    "public_id": "019e4379-b9fc-7318-93c0-77558784c898",
    "storage_key": "property/5656427712479232/019e4379-b9fc-7318-93c0-77558784c898.webp",
    "width": 3072,
    "height": 3072
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019d02ef-f872-71ed-8929-4089e2e34cda.webp",
  "property_secondary_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ef-f872-71ed-8929-4089e2e34cda",
    "storage_key": "property/5656427712479232/019d02ef-f872-71ed-8929-4089e2e34cda.webp",
    "width": 325,
    "height": 147
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019e4379-572d-7380-b52c-4d2768f3adba.webp",
  "property_icon_media": {
    "alt_text": "Green abstract logo with curved lines",
    "public_id": "019e4379-572d-7380-b52c-4d2768f3adba",
    "storage_key": "property/5656427712479232/019e4379-572d-7380-b52c-4d2768f3adba.webp",
    "width": 678,
    "height": 678
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019e4379-572d-7380-b52c-4d2768f3adba.webp",
  "property_fav_icon_media": {
    "alt_text": "Green abstract logo with curved lines",
    "public_id": "019e4379-572d-7380-b52c-4d2768f3adba",
    "storage_key": "property/5656427712479232/019e4379-572d-7380-b52c-4d2768f3adba.webp",
    "width": 678,
    "height": 678
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019e4379-b239-777b-88cd-7f6dfc735156.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Cadence at Cates Creek logo",
    "public_id": "019e4379-b239-777b-88cd-7f6dfc735156",
    "storage_key": "property/5656427712479232/019e4379-b239-777b-88cd-7f6dfc735156.webp",
    "width": 3072,
    "height": 3072
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019e4379-baf3-72fb-bf26-800f24df3732.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Cadence at Cates Creek logo.",
    "public_id": "019e4379-baf3-72fb-bf26-800f24df3732",
    "storage_key": "property/5656427712479232/019e4379-baf3-72fb-bf26-800f24df3732.webp",
    "width": 3072,
    "height": 3072
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#006937",
  "property_secondary_color": "#3dae2b",
  "property_font_color": "#2e2a25",
  "property_color_4": null,
  "property_color_3": "#6f7271",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "753 - 1509",
  "property_sqft_min": "753",
  "property_sqft_max": "1509",
  "property_price_range": "1315 - 2226",
  "property_price_min": "1315",
  "property_price_max": "2226",
  "property_available_units": 18,
  "property_facebook_url": "https://www.facebook.com/CadenceCatesCreek",
  "property_instagram_url": "https://www.instagram.com/cadenceatcatescreek",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJSYsIQcferIkRgMemox72uTg",
  "property_youtube_url": "https://www.youtube.com/@CadenceatCatesCreek",
  "property_yelp_url": "https://www.yelp.com/biz/ardmore-cates-creek-hillsborough",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": "<p><strong>Amenity-rich living, made easy.</strong> Cadence at Cates Creek brings standout spaces into every day, from a resort-style pool with grilling pavilion to a 24-hour fitness center, clubhouse lounge, business center, and Starbucks coffee bar. Inside, granite countertops, designer cabinetry, wood-style flooring, 9-foot ceilings with crown molding, and walk-in closets add polish to your Hillsborough apartment—while a pet park, wash station, car care station, and available garages round out the convenience.</p>",
  "property_home_floorplans_blurb": "<p><strong>Find the layout that fits.</strong> Explore one, two, and three bedroom apartments in Hillsborough with open living spaces, granite-topped kitchens, designer cabinetry, and stainless-steel-style appliances. Wood-style flooring, 9-foot ceilings with crown molding, walk-in closets, and washer/dryer connections bring polish to the everyday, with select homes offering a patio or Juliette balcony.</p>",
  "property_home_gallery_blurb": "<p><strong>See Cadence at Cates Creek in focus.</strong> Preview bright interiors with granite countertops, wood-style flooring, and open living spaces, then step into community scenes made for easy downtime: a resort-style pool, grilling pavilion, clubhouse lounge with coffee bar, and outdoor fireplace. Browse the full gallery for a closer look at the details that shape everyday living in Hillsborough.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Hillsborough, connected in every direction.</strong> Cadence at Cates Creek puts the Waterstone district, downtown Hillsborough, Chapel Hill, and Durham within easy reach. Grab coffee at Weaver Street Market, dinner at Saratoga Grill, or pub fare at The Wooden Nickel, then trade streetscapes for the Eno River, Riverwalk, Gold Park, or the Historic Occoneechee Speedway Trail. Closer by, Cates Creek Park and UNC Hospitals Hillsborough Campus keep green space and everyday essentials close to home.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents say Cadence at Cates Creek feels easy to love.</strong> Reviews highlight prompt maintenance, a courteous leasing team, quiet well-kept grounds, and everyday conveniences that make a difference. Roomy layouts, generous storage, stainless steel finishes, hardwood floors, a clean pool and gym, helpful front desk support, friendly neighbors, and weekly food trucks all get shoutouts. See why one review calls it “Home Sweet Home.”</p>",
  "property_neighborhood_blurb": "<p><strong>Your Hillsborough map opens in every direction.</strong> From Cadence at Cates Creek, you’re positioned near the Waterstone district with quick connections to Chapel Hill, Durham, and the character-rich blocks of downtown Hillsborough. Head for Churton Street when the day calls for local flavor—coffee and groceries at Weaver Street Market, pub fare at The Wooden Nickel, or dinner tucked above the street at Saratoga Grill—then follow the Eno River toward Riverwalk, Gold Park, and the Historic Occoneechee Speedway Trail.</p><p>Closer to home, Cates Creek Park adds open green space, picnic spots, and everyday breathing room, while UNC Hospitals Hillsborough Campus and major routes keep practical destinations within easy reach. Explore the map below, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how naturally the neighborhood fits your routine.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Live with more built into your day.</strong> At Cadence at Cates Creek, amenities are designed to make home feel effortless, from a resort-style pool with a grilling pavilion to a 24-hour fitness center, business center, and clubhouse lounge for a quick change of pace.</p><p>Inside your Hillsborough apartment, modern kitchens with granite countertops, designer cabinetry, and stainless-steel-style appliances pair with wood-style flooring, 9-foot ceilings with crown molding, walk-in closets, and open-concept layouts. Everyday extras go beyond the expected, too, with a Starbucks coffee bar, car care station, available garages, online resident services, and credit-building support through RentPlus. Pet-friendly conveniences include a pet park and wash station; see the <a href=\"/pet-policy\">pet policy</a> for details, then browse the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_applynow_blurb": "<p><strong>Start your next chapter at Cadence at Cates Creek.</strong><br>Choose a one, two, or three bedroom apartment with open-concept space, granite countertops, wood-style flooring, walk-in closets, and a private patio or Juliette balcony. When you’re ready, begin your application online and move one step closer to home.</p>",
  "property_contactus_blurb": "<p><strong>Have questions or need directions?</strong> The Cadence at Cates Creek leasing team is here to help you learn more about our one, two, and three bedroom apartments near UNC Hospitals Hillsborough Campus, I-40, and historic downtown Hillsborough. Reach out today—we’d love to hear from you.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Cadence at Cates Creek?</strong> Start here for quick answers about the community, leasing, apartment features, and everyday living. If you don’t see what you need, the leasing team is happy to help you take the next step.</p>",
  "property_floorplans_blurb": "<p><strong>Choose your next layout with confidence.</strong> Cadence at Cates Creek gives you a focused collection of one, two, and three bedroom apartments in Hillsborough, so it’s easy to compare the amount of space, bedroom count, and availability that works for your plans. Open-concept living areas flow into modern kitchens with granite countertops, designer cabinetry, stainless-steel-style appliances, and built-in microwaves, while wood-style flooring, 9-foot ceilings with crown molding, walk-in closets, and washer and dryer connections add everyday ease. Select homes also include a private patio or Juliette balcony. Browse the floor plan cards below, review current pricing, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorite layout in person.</p>",
  "property_gallery_blurb": "<p><strong>Picture the details before you arrive.</strong> Browse the Cadence at Cates Creek photo gallery for a closer look at bright apartment interiors, polished kitchens with granite countertops, wood-style flooring, and open living areas designed to feel easy from the first glance.</p><p>Then follow the camera outdoors: a resort-style pool framed for unhurried afternoons, a grilling pavilion ready for laid-back meals, a clubhouse lounge with a coffee-bar moment, and an outdoor fireplace that adds a warm finish to the scene. You’ll also catch glimpses of practical everyday spaces, from the business center to pet-friendly features. Explore the photos, compare your favorite <a href=\"/floor-plans\">one, two, or three bedroom layout</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to experience this Hillsborough apartment community in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Find your place in Hillsborough.</strong> Use the interactive map to explore available one, two, and three bedroom apartments at Cadence at Cates Creek, then see what’s nearby—from UNC Hospitals Hillsborough Campus and I-40 access to historic downtown dining, shopping, and outdoor escapes.</p>",
  "property_pets_blurb": "<p><strong>Room to roam, rinse, and relax.</strong> At Cadence at Cates Creek, your pet-friendly routine starts close to home: take your dog to the on-site pet park, use the pet wash station after muddy outings, then head back to a comfortable apartment with open living space made for easy everyday flow. Cats and dogs are welcome, with policy details listed below so you can plan with clarity.</p><p>When errands or appointments are on the calendar, Hillsborough pet care and supplies are within easy reach, and nearby green space makes fresh-air breaks simple. Explore more <a href=\"/amenities\">pet-friendly amenities</a>, compare <a href=\"/floor-plans\">available floor plans</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see how smoothly your pet’s day can fit here.</p>",
  "property_referafriend_blurb": "<p><strong>Share modern comfort with Hillsborough character.</strong> Love the open-concept layouts, polished finishes, resort-style spaces, and easy access to downtown Hillsborough? Invite a friend to discover Cadence at Cates Creek and find a one, two, or three bedroom apartment to call home.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access made easy.</strong><br>At Cadence at Cates Creek, online resident services help keep daily living convenient. Log in to pay rent, submit maintenance requests, and manage your account—all in one simple place designed to support the comfort and ease of your Hillsborough apartment home.</p>",
  "property_reviews_blurb": "<p><strong>Hear what residents appreciate most.</strong> Reviews for Cadence at Cates Creek often point to the everyday details that make apartment living feel easy: prompt, friendly maintenance, a courteous leasing team, and a community that’s quiet and well maintained. Residents mention roomy layouts with generous storage, beautiful finishes like stainless steel and hardwood floors, and well-kept spaces including the pool and gym.</p><p>You’ll also see praise for quick service, helpful front desk support, friendly neighbors, and community touches like weekly food trucks. One resident summed it up simply: “Home Sweet Home.” Browse the reviews below to see why residents highly recommend Cadence at Cates Creek.</p>",
  "property_created_at": "1752256415203",
  "property_scheduletour_blurb": "<p><strong>See Cadence at Cates Creek in person.</strong> Tour spacious one-, two-, and three-bedroom apartments with sleek kitchen finishes, hard-surface flooring, and full-size washers and dryers, then explore inviting community spaces like the pool, fitness center, clubhouse, coffee bar, and outdoor gathering areas. Schedule your tour today.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—your inquiry has been received.</strong> The Cadence at Cates Creek leasing team will be in touch soon. In the meantime, imagine life with spacious one-, two-, and three-bedroom layouts, modern finishes, full-size washers and dryers, and inviting spaces like the pool, clubhouse, coffee bar, and dog park.</p>",
  "property_virtualtours_blurb": "<p><strong>Walk through Cadence at Cates Creek on your own time.</strong> Start with the community tour, then step inside the clubhouse and fitness center to get a true sense of the spaces that shape daily life at this Hillsborough apartment community. From there, explore the two- and three-bedroom apartment tours, where open-concept living areas, modern kitchens, wood-style flooring, tall ceilings, and generous storage are easier to picture in motion.</p><p>Use each virtual walkthrough to compare flow, finishes, and room-to-room connection before you visit in person. When a layout catches your eye, review current <a href=\"/floor-plans\">floor plans</a>, browse more <a href=\"/gallery\">photos</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see Cadence at Cates Creek up close.</p>",
  "property_copyright": "2025 All Rights Reserved. Cadence at Cates Creek",
  "property_seo_title_home": "Cadence at Cates Creek | Apartments in Hillsborough, NC",
  "property_seo_description_home": "Discover your perfect home at Cadence at Cates Creek in Hillsborough, NC! Explore our stylish one, two, and three-bedroom floor plans featuring modern amenities like a fitness center, pool, and dog park. Enjoy conveniences such as smart locks, laundry rooms, and an on-site business center. Our community boasts stunning crown molding, hardwood flooring, and a cozy coffee bar. Experience the best in apartment living—find your new home today!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 3 Apartments in Hillsborough, NC",
  "property_seo_description_floorplans": "Discover your ideal living space at Cadence at Cates Creek in beautiful Hillsborough, NC. Explore our thoughtfully designed floor plans, featuring one, two, and three-bedroom options to suit your lifestyle. Browse our available apartment homes today and find your perfect fit!",
  "property_seo_title_amenities": "Amenities | Hillsborough, NC Apartments for Rent",
  "property_seo_description_amenities": "Discover modern living at Cadence at Cates Creek in Hillsborough, NC! Choose from spacious one, two, and three-bedroom floor plans, equipped with luxurious amenities like a fitness center, pool, business center, dog park, and fire pit. Enjoy stylish interiors featuring smart locks, crown molding, and premium finishes. Dive into our vibrant community life—explore our online resident services, on-site coffee bar, and more! Don't miss out—explore our amazing community amenities and apartment features today!",
  "property_seo_title_gallery": "Gallery | Apartments in Hillsborough, NC",
  "property_seo_description_gallery": "\"Discover your dream home at Cadence at Cates Creek in Hillsborough, NC! Explore our variety of floor plans, including one, two, and three-bedroom apartments designed with premium amenities like a state-of-the-art fitness center, relaxing pool, and a welcoming clubhouse. Enjoy the convenience of smart locks, in-unit laundry, and gorgeous finishes. Don’t miss our dog park, grill area, and outdoor spaces perfect for entertaining. Picture yourself living in comfort and style—check out our photo gallery today!\"",
  "property_seo_title_virtualtours": "Virtual Tours | Cadence at Cates Creek Apartments",
  "property_seo_description_virtualtours": "Discover the perfect home at Cadence at Cates Creek in Hillsborough, NC! Explore our inviting one, two, and three-bedroom floor plans to find your ideal space. Take a virtual tour of our vibrant community and see why our apartments for rent are the perfect choice for your next chapter. Visit us today!",
  "property_seo_title_interactivemap": "Interactive Map | Cadence at Cates Creek Apartments",
  "property_seo_description_interactivemap": "Discover your perfect home at Cadence at Cates Creek in Hillsborough, NC! Explore our spacious one, two, and three-bedroom floor plans designed with luxurious amenities like a fitness center, dog park, and resort-style pool. Enjoy modern conveniences such as smart locks, built-in microwaves, and convenient laundry rooms. Use our interactive community map to find available apartments, view pricing, and select your new home today! Make Cadence at Cates Creek your next chapter.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Hillsborough, NC",
  "property_seo_description_neighborhood": "Discover the vibrant community surrounding Cadence at Cates Creek in Hillsborough, NC! Explore our one, two, and three-bedroom floor plans while immersing yourself in local favorites and nearby attractions. See what's around our community and uncover the perfect blend of comfort and convenience. Your ideal neighborhood awaits!",
  "property_seo_title_contact": "Contact Us | Cadence at Cates Creek",
  "property_seo_description_contact": "Explore your dream home at Cadence at Cates Creek in Hillsborough, NC! Our inviting community offers a variety of spacious floor plans, including one, two, and three-bedroom apartments designed for your lifestyle. Have questions? Contact our leasing team today to find out more about our amenities and availability!",
  "property_seo_title_faqs": "FAQs | Apartments in Hillsborough, NC",
  "property_seo_description_faqs": "Discover the perfect home at Cadence at Cates Creek in Hillsborough, NC! Explore our diverse floor plans, including one, two, and three-bedroom apartments, and enjoy top-notch amenities like a fitness center, dog park, and pool. With features such as smart locks, hardwood flooring, and spacious walk-in closets, your comfort is our priority. Have questions? Browse our FAQs page to find answers and learn why our community is the ideal place to call home!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Hillsborough, NC",
  "property_seo_description_reviews": "Experience the vibrant community at Cadence at Cates Creek in Hillsborough, NC! Explore our diverse floor plans, from cozy one-bedroom to spacious three-bedroom apartments, all featuring premium amenities like a fitness center, dog park, and resort-style pool. With modern conveniences like smart locks, built-in microwaves, and online resident services, living here has never been easier. Curious about life in our community? See what our residents have to say about enjoying their home at Cadence at Cates Creek today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Hillsborough, NC",
  "property_seo_description_applynow": "Discover your dream home at Cadence at Cates Creek in Hillsborough, NC! Choose from spacious one, two, and three-bedroom floor plans featuring exceptional amenities such as a resort-style pool, state-of-the-art fitness center, and dog park. Enjoy modern comforts with built-in microwaves, smart locks, and hardwood flooring. With online resident services and a welcoming clubhouse, everything you need is right at your fingertips. Don't wait—apply now and lease your perfect apartment online today!",
  "property_seo_title_residentaccess": "Resident Access | Cadence at Cates Creek",
  "property_seo_description_residentaccess": "\"Welcome to the Resident Access Login for Cadence at Cates Creek in Hillsborough, NC. Easily pay rent, schedule maintenance, and explore community resources. Access your portal now for a seamless living experience!\"",
  "property_seo_title_referafriend": "Refer A Friend | Cadence at Cates Creek",
  "property_seo_description_referafriend": "\"Great friends make great neighbors! Refer a friend to Cadence at Cates Creek in Hillsborough, NC, and enjoy a vibrant community together. Discover beautiful apartments, exceptional amenities, and a welcoming atmosphere that your friends will love. Share the joy of perfect living today!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Cadence at Cates Creek",
  "property_seo_description_scheduletour": "\"Discover your new home at Cadence at Cates Creek in beautiful Hillsborough, NC! Schedule a tour today to explore our vibrant community, modern amenities, and spacious apartments. Experience the perfect blend of comfort and convenience—your dream home awaits!\"",
  "property_seo_title_privacy": "Privacy Policy | Cadence at Cates Creek",
  "property_seo_description_privacy": "\"Discover the commitment to your privacy at Cadence at Cates Creek in Hillsborough, NC. Our transparent privacy policy outlines how we protect your personal information. View our privacy policy today to learn more!\"",
  "property_seo_title_accessibility": "Website Accessibility | Cadence at Cates Creek",
  "property_seo_description_accessibility": "\"Discover Cadence at Cates Creek in Hillsborough, NC, where we prioritize accessibility for all. Our commitment to digital inclusion ensures everyone can enjoy our vibrant community. Explore our Accessibility Statement to learn more. Join us today!\"",
  "property_seo_title_sitemap": "Sitemap | Cadence at Cates Creek",
  "property_seo_description_sitemap": "Explore Cadence at Cates Creek in Hillsborough, NC! Our sitemap provides a comprehensive overview of our vibrant apartment community, amenities, and nearby attractions. Discover your perfect home today—view our sitemap now!",
  "property_seo_title_thankyou": "Thank You | Cadence at Cates Creek",
  "property_seo_description_thankyou": "Thank you for reaching out to Cadence at Cates Creek in Hillsborough, NC! Your interest is important to us, and a member of our team will be in touch soon to assist you. Discover your perfect home in our vibrant community, where comfort and convenience meet.",
  "property_seo_title_pets": "Pet Policy | Apartments in Summerville, SC\r",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793651137132",
  "amenities": [
    {
      "id": "ec_1819bee003d7723bbc53fef0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "external_id": "false",
      "title": "Resort Style Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_16684ec43c1962c4f66f3305",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "external_id": "false",
      "title": "24 Hour Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_98f1477bdb9c0a8907dd4cc6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "external_id": "false",
      "title": "Modern Clubhouse With Resident Lounge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7471680e3262fec5f3b7adbb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "external_id": "false",
      "title": "High‑Tech Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b009ecec21d91ebf4cd7a267",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "external_id": "false",
      "title": "Personal Garages Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_18ef9d59895b0012654561fc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "external_id": "false",
      "title": "Outdoor Fireplace With Relaxing Lounge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_52b6e7e28d1c98f3441a3b11",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "external_id": "false",
      "title": "Poolside Grilling Pavilion",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d1fcc1e1f0bba98752d1b548",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "external_id": "false",
      "title": "Complimentary Starbucks Coffee Bar",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e1baf99a4f60f3dbe7062f8e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "external_id": "false",
      "title": "Pet Park With Pet Wash Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4b928758421814f4a3c3ec3f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "external_id": "false",
      "title": "Car Care Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6d5fd389e31b3cfa02db3e9d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "external_id": "false",
      "title": "Credit Building Services Powered by RentPlus",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_612dcac01cc8743fb31c1114",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "external_id": "false",
      "title": "Convenient 24/7 Online Resident Services",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ba7d47ec6142573ce184c07e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "external_id": "false",
      "title": "American Landmark 360 Resident Program",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_db1b21db85655bf403b6887c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "external_id": "false",
      "title": "1, 2 & 3 Bedroom Floor Plans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_793c6d3cae8d8c91e719b56a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "external_id": "false",
      "title": "Stainless‑Steel‑Style Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9bf3982b5dcc3909d8a84418",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "external_id": "false",
      "title": "Modern Kitchens",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0cc673a4deb1737378435643",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "external_id": "false",
      "title": "Granite Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e861fb1806692fbf748da60f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "external_id": "false",
      "title": "Designer Cabinetry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_12923d5347e4666a03bc78dd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "external_id": "false",
      "title": "Built‑In Microwaves",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9f11e7edd417b76008b2f0a4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "external_id": "false",
      "title": "Brushed Nickel Finishes",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8b4807d6cb4f1d7030eebb70",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "external_id": "false",
      "title": "Wood‑Style Flooring",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cdc756f07103687c325b4d26",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "external_id": "false",
      "title": "9‑Foot Ceilings With Crown Molding",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2c3d10a7bc38b71aa772473a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "external_id": "false",
      "title": "Walk‑In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ea0cf747d6d7357ae0a04e7e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "external_id": "false",
      "title": "Washer & Dryer Connections",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9a4126ddf67764c16130d86a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "external_id": "false",
      "title": "Private Patio or Juliette Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dd1c4caea2b1c33b2541d0c4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "external_id": "false",
      "title": "Open Concept Floor Plans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b1ffd62fa148ed0292047052",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "external_id": "false",
      "title": "Pool Views*",
      "amount": "false",
      "description": "*In Select Homes",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e5a314caaaf71cc98d13b00b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "external_id": "false",
      "title": "Pet‑Friendly Homes",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_8cffabe4-42ef-4fb4-85fa-1efa26cdd8bf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019e8981-4947-755e-a466-80c6b8479dc7.webp",
      "image_media": {
        "alt_text": "Co-working space with a high table, laptops, printer, and seating.",
        "public_id": "019e8981-4947-755e-a466-80c6b8479dc7",
        "storage_key": "property/5656427712479232/019e8981-4947-755e-a466-80c6b8479dc7.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Utilize the co-working space with high-speed internet, laptops, and a printer for your work needs.",
      "link": "",
      "alt_text": "Co-working space with a high table, laptops, printer, and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ae035315-4327-4eb8-b1e9-e8d65b5e241e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019e8981-4cce-74c6-9a23-0d8cce4c3050.webp",
      "image_media": {
        "alt_text": "In-unit washer and dryer with kitchen visible in background.",
        "public_id": "019e8981-4cce-74c6-9a23-0d8cce4c3050",
        "storage_key": "property/5656427712479232/019e8981-4cce-74c6-9a23-0d8cce4c3050.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Enjoy the convenience of a full-size washer and dryer in your apartment home, with a modern kitchen nearby.",
      "link": "",
      "alt_text": "In-unit washer and dryer with kitchen visible in background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fa6c3f07-29a9-4dbd-876c-f723fcb8529a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019e8981-4c10-7770-8c93-363a5b2643ad.webp",
      "image_media": {
        "alt_text": "Cozy living room with a sectional sofa, coffee table, and TV.",
        "public_id": "019e8981-4c10-7770-8c93-363a5b2643ad",
        "storage_key": "property/5656427712479232/019e8981-4c10-7770-8c93-363a5b2643ad.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Relax in this inviting living room featuring a comfortable sectional sofa, a stylish coffee table, and a modern entertainment center.",
      "link": "",
      "alt_text": "Cozy living room with a sectional sofa, coffee table, and TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b5491d1e-5515-4018-93c8-f33ba274c4f5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019e8981-5580-7437-aeca-515b11dc89a9.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and buildings in the background.",
        "public_id": "019e8981-5580-7437-aeca-515b11dc89a9",
        "storage_key": "property/5656427712479232/019e8981-5580-7437-aeca-515b11dc89a9.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool, surrounded by comfortable lounge chairs and scenic views of the community buildings. Perfect for a sunny afternoon.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_62c2a689-cc8b-4f0f-973a-70b8801cd2d6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019e8981-3d67-716f-876d-c1e01767abbc.webp",
      "image_media": {
        "alt_text": "A fenced-in dog park with agility equipment and apartment buildings in the background.",
        "public_id": "019e8981-3d67-716f-876d-c1e01767abbc",
        "storage_key": "property/5656427712479232/019e8981-3d67-716f-876d-c1e01767abbc.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy our spacious dog park, complete with agility equipment for your furry friends to play and socialize in.",
      "link": "",
      "alt_text": "A fenced-in dog park with agility equipment and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ff67d5ab-f396-4466-acc8-d7b2d6d9f7e4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019e8981-4861-7242-a3ff-2ade14787780.webp",
      "image_media": {
        "alt_text": "Covered outdoor seating area with grills and bar seating at a multifamily property.",
        "public_id": "019e8981-4861-7242-a3ff-2ade14787780",
        "storage_key": "property/5656427712479232/019e8981-4861-7242-a3ff-2ade14787780.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy outdoor living with comfortable seating areas and grilling stations, perfect for entertaining guests at this multifamily property.",
      "link": "",
      "alt_text": "Covered outdoor seating area with grills and bar seating at a multifamily property.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e7307385-8a87-4490-bca7-288343abe8d4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019e8981-4f4d-75fa-9b1d-b5f4b7d1767f.webp",
      "image_media": {
        "alt_text": "Modern living room with plush seating and abstract art.",
        "public_id": "019e8981-4f4d-75fa-9b1d-b5f4b7d1767f",
        "storage_key": "property/5656427712479232/019e8981-4f4d-75fa-9b1d-b5f4b7d1767f.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish communal living space, featuring comfortable seating and contemporary decor.",
      "link": "",
      "alt_text": "Modern living room with plush seating and abstract art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7833ddb4-b212-4752-9bee-d1e41820a049",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019e8981-4e1a-7349-bbba-6b2cd64ed895.webp",
      "image_media": {
        "alt_text": "Package lockers in the building lobby with the property logo visible on a mat.",
        "public_id": "019e8981-4e1a-7349-bbba-6b2cd64ed895",
        "storage_key": "property/5656427712479232/019e8981-4e1a-7349-bbba-6b2cd64ed895.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Secure package lockers available for residents, conveniently located in the building lobby.",
      "link": "",
      "alt_text": "Package lockers in the building lobby with the property logo visible on a mat.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6d5b8f73-27e3-4c10-97c8-3748eefefc90",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019e8981-4a32-75e8-9c39-7d297c27a0d7.webp",
      "image_media": {
        "alt_text": "Weight rack with dumbbells, kettlebells, and medicine balls, plus a bench and jump ropes. Medicine balls and a step platform are on the floor.",
        "public_id": "019e8981-4a32-75e8-9c39-7d297c27a0d7",
        "storage_key": "property/5656427712479232/019e8981-4a32-75e8-9c39-7d297c27a0d7.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with a comprehensive weight rack, bench, and various training accessories.",
      "link": "",
      "alt_text": "Weight rack with dumbbells, kettlebells, and medicine balls, plus a bench and jump ropes. Medicine balls and a step platform are on the floor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4b71d32a-a1b1-475e-83ac-cf73fc431ad1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019e8981-3b54-7479-94f5-63afba5e5fff.webp",
      "image_media": {
        "alt_text": "Stylish bedroom with a king-size bed, modern art, and a comfortable accent chair.",
        "public_id": "019e8981-3b54-7479-94f5-63afba5e5fff",
        "storage_key": "property/5656427712479232/019e8981-3b54-7479-94f5-63afba5e5fff.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Discover comfort and style in our spacious bedrooms, featuring plush bedding and elegant decor for a relaxing retreat.",
      "link": "",
      "alt_text": "Stylish bedroom with a king-size bed, modern art, and a comfortable accent chair.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_747eab02-87cb-499d-b63c-fe4a1944443e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019e8981-3576-70f2-a267-de4edfc788d2.webp",
      "image_media": {
        "alt_text": "Interior of a furnished apartment living room and kitchen area with hardwood floors and modern decor.",
        "public_id": "019e8981-3576-70f2-a267-de4edfc788d2",
        "storage_key": "property/5656427712479232/019e8981-3576-70f2-a267-de4edfc788d2.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Beautifully appointed living room and kitchen area in an apartment, featuring modern finishes, comfortable seating, and a fully equipped kitchen.",
      "link": "",
      "alt_text": "Interior of a furnished apartment living room and kitchen area with hardwood floors and modern decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0724fb7b-7fb8-4fac-9ecc-3bc1b110dd8b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019e8981-35cf-712c-ac99-4c7e491e870e.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool and jacuzzi with lounge chairs and a covered pavilion.",
        "public_id": "019e8981-35cf-712c-ac99-4c7e491e870e",
        "storage_key": "property/5656427712479232/019e8981-35cf-712c-ac99-4c7e491e870e.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool and jacuzzi. Enjoy the sun on our comfortable lounge chairs or find shade under the covered pavilion.",
      "link": "",
      "alt_text": "Resort-style swimming pool and jacuzzi with lounge chairs and a covered pavilion.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_63ad51ea-2deb-465b-afa3-359e5dcddfda",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019e8981-3015-7139-bd72-95d01a1150e8.webp",
      "image_media": {
        "alt_text": "Aerial view of a large apartment complex with multiple buildings, a central courtyard with a pool, parking lots, and lush landscaping.",
        "public_id": "019e8981-3015-7139-bd72-95d01a1150e8",
        "storage_key": "property/5656427712479232/019e8981-3015-7139-bd72-95d01a1150e8.webp",
        "width": 3072,
        "height": 2046
      },
      "title": "Community",
      "description": "Discover our vibrant apartment community, featuring beautiful buildings, a sparkling pool, and ample green spaces for relaxation and recreation.",
      "link": "",
      "alt_text": "Aerial view of a large apartment complex with multiple buildings, a central courtyard with a pool, parking lots, and lush landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f1ab1619-740f-4a52-bd9c-9000eb89cada",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019e8981-30c9-70df-8f3a-610b24157e10.webp",
      "image_media": {
        "alt_text": "Empty closet with clothes hangers and storage baskets",
        "public_id": "019e8981-30c9-70df-8f3a-610b24157e10",
        "storage_key": "property/5656427712479232/019e8981-30c9-70df-8f3a-610b24157e10.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious closet featuring clothing hangers and decorative storage baskets, ready for your personal belongings.",
      "link": "",
      "alt_text": "Empty closet with clothes hangers and storage baskets",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_be4173e2-5c74-4ce2-81d6-2d3763eb0e2b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019e8981-2fe1-7420-a53d-a1c495426ef3.webp",
      "image_media": {
        "alt_text": "Luxury apartment community pool area with lounge chairs and umbrellas at sunset.",
        "public_id": "019e8981-2fe1-7420-a53d-a1c495426ef3",
        "storage_key": "property/5656427712479232/019e8981-2fe1-7420-a53d-a1c495426ef3.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool, surrounded by comfortable lounge chairs and lush landscaping. Perfect for soaking up the sun or enjoying a refreshing dip.",
      "link": "",
      "alt_text": "Luxury apartment community pool area with lounge chairs and umbrellas at sunset.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3ed6cbd3-a02c-45f3-8079-66865083bba5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019e8981-2ec7-72aa-a123-7ea9e73393cf.webp",
      "image_media": {
        "alt_text": "Modern living room and kitchen with beige sofa, coffee table, and wooden cabinets.",
        "public_id": "019e8981-2ec7-72aa-a123-7ea9e73393cf",
        "storage_key": "property/5656427712479232/019e8981-2ec7-72aa-a123-7ea9e73393cf.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious and elegantly furnished living area seamlessly connected to a modern kitchen, perfect for entertaining or relaxing.",
      "link": "",
      "alt_text": "Modern living room and kitchen with beige sofa, coffee table, and wooden cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0666124f-821c-4cac-817c-d039b58953d5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019e8981-2ce3-707b-836f-40b4a1cdf748.webp",
      "image_media": {
        "alt_text": "Modern fitness center with cardio machines and weight training equipment.",
        "public_id": "019e8981-2ce3-707b-836f-40b4a1cdf748",
        "storage_key": "property/5656427712479232/019e8981-2ce3-707b-836f-40b4a1cdf748.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, equipped with treadmills, stationary bikes, and weight machines for a complete workout.",
      "link": "",
      "alt_text": "Modern fitness center with cardio machines and weight training equipment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_37329fb4-569c-4cc8-be87-1dd7ce96fc4a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019e8981-2eb2-71cb-b097-84baaf9f0bc4.webp",
      "image_media": {
        "alt_text": "Modern bathroom with wood vanity, white countertop, sink, large mirror, and bathtub with shower.",
        "public_id": "019e8981-2eb2-71cb-b097-84baaf9f0bc4",
        "storage_key": "property/5656427712479232/019e8981-2eb2-71cb-b097-84baaf9f0bc4.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Step into a clean and updated bathroom, featuring a spacious vanity, a bright mirror, and a convenient bathtub and shower combination.",
      "link": "",
      "alt_text": "Modern bathroom with wood vanity, white countertop, sink, large mirror, and bathtub with shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cac933af-06ed-43e9-9a4f-3436a2eb58b4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019e8981-1778-7109-b211-c52b9865af36.webp",
      "image_media": {
        "alt_text": "Dog park with agility equipment, benches, and rules sign.",
        "public_id": "019e8981-1778-7109-b211-c52b9865af36",
        "storage_key": "property/5656427712479232/019e8981-1778-7109-b211-c52b9865af36.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy our dedicated dog park, complete with agility equipment and benches, perfect for your furry friends to play and socialize.",
      "link": "",
      "alt_text": "Dog park with agility equipment, benches, and rules sign.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c3c76774-bf78-42ab-897c-53ca172b90e2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019e8981-2225-75b8-a0eb-02c48fdfe2fb.webp",
      "image_media": {
        "alt_text": "Round marble dining table with plush chairs in a community lounge.",
        "public_id": "019e8981-2225-75b8-a0eb-02c48fdfe2fb",
        "storage_key": "property/5656427712479232/019e8981-2225-75b8-a0eb-02c48fdfe2fb.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Gather around the elegant round marble dining table, surrounded by plush seating, in our beautifully appointed community lounge.",
      "link": "",
      "alt_text": "Round marble dining table with plush chairs in a community lounge.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a83ca6e8-8737-46d4-8960-bd680f6f6745",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019e8981-103c-7324-9a94-5576f2d50eb0.webp",
      "image_media": {
        "alt_text": "Aerial view of a large outdoor swimming pool with lounge chairs and umbrellas.",
        "public_id": "019e8981-103c-7324-9a94-5576f2d50eb0",
        "storage_key": "property/5656427712479232/019e8981-103c-7324-9a94-5576f2d50eb0.webp",
        "width": 3072,
        "height": 2046
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our stunning outdoor swimming pool, surrounded by comfortable lounge chairs and umbrellas for ultimate relaxation.",
      "link": "",
      "alt_text": "Aerial view of a large outdoor swimming pool with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b4f1f2f7-c8bb-4a54-91b0-221f8dac9beb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019e8981-15aa-7026-8210-f773879b0e21.webp",
      "image_media": {
        "alt_text": "Spacious apartment gym with treadmills, ellipticals, weight machines, and exercise bikes.",
        "public_id": "019e8981-15aa-7026-8210-f773879b0e21",
        "storage_key": "property/5656427712479232/019e8981-15aa-7026-8210-f773879b0e21.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring a variety of cardio machines and strength training equipment for your workout needs.",
      "link": "",
      "alt_text": "Spacious apartment gym with treadmills, ellipticals, weight machines, and exercise bikes.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9a26913c-6def-410f-abad-ee9506358321",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019e8981-1061-753b-ae4b-90c41fc6a08e.webp",
      "image_media": {
        "alt_text": "Covered patio with outdoor seating, fireplace, and TV overlooking a swimming pool.",
        "public_id": "019e8981-1061-753b-ae4b-90c41fc6a08e",
        "storage_key": "property/5656427712479232/019e8981-1061-753b-ae4b-90c41fc6a08e.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and unwind on the covered patio, complete with comfortable seating, a fireplace, and a large TV, just steps away from the sparkling swimming pool.",
      "link": "",
      "alt_text": "Covered patio with outdoor seating, fireplace, and TV overlooking a swimming pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e8cd06f1-b3be-4b38-8eb9-bdf9127072de",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019e8981-15c3-779b-8fd7-8454fe3f2f09.webp",
      "image_media": {
        "alt_text": "Refreshment station with coffee maker, mini-fridge, and a view of the pool.",
        "public_id": "019e8981-15c3-779b-8fd7-8454fe3f2f09",
        "storage_key": "property/5656427712479232/019e8981-15c3-779b-8fd7-8454fe3f2f09.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy complimentary refreshments at our refreshment station, complete with a coffee maker and mini-fridge, while overlooking the sparkling community pool.",
      "link": "",
      "alt_text": "Refreshment station with coffee maker, mini-fridge, and a view of the pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_07c92507-cff6-4eaf-867e-601b903a37ae",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019e8981-0ef4-7154-a87c-01defae70ade.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, toilet, and bathtub with shower curtain.",
        "public_id": "019e8981-0ef4-7154-a87c-01defae70ade",
        "storage_key": "property/5656427712479232/019e8981-0ef4-7154-a87c-01defae70ade.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Relax and refresh in this well-appointed bathroom, featuring a spacious vanity, modern toilet, and a relaxing bathtub/shower combination.",
      "link": "",
      "alt_text": "Modern bathroom with vanity, toilet, and bathtub with shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9fe27f59-5336-45ee-99eb-d7beb8e5a714",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019e8981-101e-774e-a862-db79cd2be7ad.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and wooden cabinets.",
        "public_id": "019e8981-101e-774e-a862-db79cd2be7ad",
        "storage_key": "property/5656427712479232/019e8981-101e-774e-a862-db79cd2be7ad.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Cook in style in this sleek kitchen, featuring stainless steel appliances, granite countertops, and ample cabinet space.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and wooden cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fb678f46-855a-4969-b608-6813078f3a70",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019e8981-0efb-726d-aa07-7d29a90a534b.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed and access to a bathroom.",
        "public_id": "019e8981-0efb-726d-aa07-7d29a90a534b",
        "storage_key": "property/5656427712479232/019e8981-0efb-726d-aa07-7d29a90a534b.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a queen-size bed, plush bedding, and a connecting bathroom. Perfect for relaxation and comfort.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed and access to a bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_846d3e72-0057-442a-b1d4-2615c1ed58a9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019e8981-0f64-72ec-a25f-52a2bc42639f.webp",
      "image_media": {
        "alt_text": "Modern kitchen and dining area with stainless steel appliances, granite countertops, and a wooden dining table.",
        "public_id": "019e8981-0f64-72ec-a25f-52a2bc42639f",
        "storage_key": "property/5656427712479232/019e8981-0f64-72ec-a25f-52a2bc42639f.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Enjoy cooking and dining in this stylish kitchen, featuring stainless steel appliances, granite countertops, and a comfortable dining area perfect for meals or entertaining.",
      "link": "",
      "alt_text": "Modern kitchen and dining area with stainless steel appliances, granite countertops, and a wooden dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1fc7ef29-b9a0-465b-8bfc-97b70feaaa15",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019e8981-060d-73ad-beee-c36488fbf33f.webp",
      "image_media": {
        "alt_text": "Electric vehicle charging stations in front of building entrance.",
        "public_id": "019e8981-060d-73ad-beee-c36488fbf33f",
        "storage_key": "property/5656427712479232/019e8981-060d-73ad-beee-c36488fbf33f.webp",
        "width": 3072,
        "height": 2046
      },
      "title": "Community",
      "description": "Convenient electric vehicle charging stations available for residents.",
      "link": "",
      "alt_text": "Electric vehicle charging stations in front of building entrance.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_af368939129268d0eabdbcd8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "Antonia's Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "101 N Churton St, Hillsborough, NC 27278, USA",
      "poi_short_description": "Classic Italian entrees, pasta dishes & cocktails served in an informal eatery with sidewalk tables.",
      "poi_long_description": "Classic Italian entrees, pasta dishes & cocktails served in an informal eatery with sidewalk tables.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-5631-7799-80b4-246b7311ada6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-5631-7799-80b4-246b7311ada6",
        "storage_key": "property/5656427712479232/019f150f-5631-7799-80b4-246b7311ada6.webp",
        "width": 922,
        "height": 692
      },
      "poi_business_url": "http://antoniashillsborough.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2814602185991862865&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "antonias-restaurant",
      "poi_latitude": "36.075545",
      "poi_longitude": "-79.099627",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 919-643-7722",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-d26a-777b-a0ed-32aad62790e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-d26a-777b-a0ed-32aad62790e5",
        "storage_key": "property/5656427712479232/019f150f-d26a-777b-a0ed-32aad62790e5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJL3Szbi_frIkRUToVmMZ5Dyc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "ec_75a5f4374f3ec3e266e1e37e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "Serratore's Pasta and Pizza",
      "poi_type": "Restaurants",
      "poi_address": "112 N Churton St, Hillsborough, NC 27278, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1511-95ff-74da-b0bf-761617862682.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-95ff-74da-b0bf-761617862682",
        "storage_key": "property/5656427712479232/019f1511-95ff-74da-b0bf-761617862682.webp",
        "width": 1280,
        "height": 952
      },
      "poi_business_url": "https://serratoresnc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8221631402204922295&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "serratores-pasta-and-pizza",
      "poi_latitude": "36.075868",
      "poi_longitude": "-79.099296",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 919-296-9900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-d26a-777b-a0ed-32aad62790e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-d26a-777b-a0ed-32aad62790e5",
        "storage_key": "property/5656427712479232/019f150f-d26a-777b-a0ed-32aad62790e5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJI19iFwDfrIkRtwGfQjMaGXI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_4404d983a48e52d2eee78904",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "Hillsborough Bakeshop & Cafe",
      "poi_type": "Restaurants",
      "poi_address": "110 S Churton St, Hillsborough, NC 27278, USA",
      "poi_short_description": "Quaint bakery and pasta joint with friendly staff and gluten-free options.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1511-9d63-706e-a416-df4e3c5e3bbe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-9d63-706e-a416-df4e3c5e3bbe",
        "storage_key": "property/5656427712479232/019f1511-9d63-706e-a416-df4e3c5e3bbe.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.hillsboroughbakeshop.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4993392199950593408&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hillsborough-bakeshop--cafe",
      "poi_latitude": "36.0750017",
      "poi_longitude": "-79.0995058",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 919-732-6261",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-d26a-777b-a0ed-32aad62790e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-d26a-777b-a0ed-32aad62790e5",
        "storage_key": "property/5656427712479232/019f150f-d26a-777b-a0ed-32aad62790e5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3QFdT27frIkRgO1C7r8XTEU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bakery"
    },
    {
      "id": "ec_b9c8b41acd432cbd1c6eaed1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "Saratoga Grill",
      "poi_type": "Restaurants",
      "poi_address": "108 S Churton St, Hillsborough, NC 27278, USA",
      "poi_short_description": "Seafood & steak spot known for clam chowder & housemade scones in a cozy, old-school setting.",
      "poi_long_description": "Seafood & steak spot known for clam chowder & housemade scones in a cozy, old-school setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1511-9593-71de-9ad0-6e4d74c67e5f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-9593-71de-9ad0-6e4d74c67e5f",
        "storage_key": "property/5656427712479232/019f1511-9593-71de-9ad0-6e4d74c67e5f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.saratogagrillnc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9508246003542139728&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saratoga-grill",
      "poi_latitude": "36.0750879",
      "poi_longitude": "-79.0995039",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 919-732-2214",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-d26a-777b-a0ed-32aad62790e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-d26a-777b-a0ed-32aad62790e5",
        "storage_key": "property/5656427712479232/019f150f-d26a-777b-a0ed-32aad62790e5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJB6QJai_frIkRUCMoBl0T9IM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_4eb9b09c1d6a9ec2e1976080",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "Whit's Frozen Custard",
      "poi_type": "Restaurants",
      "poi_address": "240 S Nash St, Hillsborough, NC 27278, USA",
      "poi_short_description": "Frozen custard chain with vanilla, chocolate & a rotating weekly flavor, plus a range of toppings.",
      "poi_long_description": "Frozen custard chain with vanilla, chocolate & a rotating weekly flavor, plus a range of toppings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1511-960d-70a1-92af-d045763eb3a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-960d-70a1-92af-d045763eb3a3",
        "storage_key": "property/5656427712479232/019f1511-960d-70a1-92af-d045763eb3a3.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.whitsfrozencustard.com/north-carolina/hillsborough",
      "poi_directions_map_url": "https://maps.google.com/?cid=4242303234124743451&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "whits-frozen-custard",
      "poi_latitude": "36.0721267",
      "poi_longitude": "-79.11106149999999",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 919-245-8123",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-d26a-777b-a0ed-32aad62790e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-d26a-777b-a0ed-32aad62790e5",
        "storage_key": "property/5656427712479232/019f150f-d26a-777b-a0ed-32aad62790e5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-_-m39TYrIkRGwN_k1Cw3zo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "ice_cream_shop"
    },
    {
      "id": "ec_adb01e6e24319adccb01d120",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "Hillsborough BBQ Company",
      "poi_type": "Restaurants",
      "poi_address": "236 S Nash St, Hillsborough, NC 27278, USA",
      "poi_short_description": "Comfortable barbecue spot combining traditional regional specialties with unconventional options.",
      "poi_long_description": "Comfortable barbecue spot combining traditional regional specialties with unconventional options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-5889-71f9-97f0-20232f082d0f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-5889-71f9-97f0-20232f082d0f",
        "storage_key": "property/5656427712479232/019f150f-5889-71f9-97f0-20232f082d0f.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "http://hillsboroughbbq.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17255100082706224473&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hillsborough-bbq-company",
      "poi_latitude": "36.0722125",
      "poi_longitude": "-79.11124509999999",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 919-732-4647",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-d26a-777b-a0ed-32aad62790e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-d26a-777b-a0ed-32aad62790e5",
        "storage_key": "property/5656427712479232/019f150f-d26a-777b-a0ed-32aad62790e5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJkQJx4NTYrIkRWZWEkRpudu8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "ec_e3aa9a2371c8c2f5adb173d5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "Nash Street Tavern",
      "poi_type": "Restaurants",
      "poi_address": "250 S Nash St, Hillsborough, NC 27278, USA",
      "poi_short_description": "Casual watering hole with live music on weekends, plus bar games and outdoor seating.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1511-a16a-747f-a509-a70f36f650d5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-a16a-747f-a509-a70f36f650d5",
        "storage_key": "property/5656427712479232/019f1511-a16a-747f-a509-a70f36f650d5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.facebook.com/NashStreetTavern/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4897883033070948278&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nash-street-tavern",
      "poi_latitude": "36.0719266",
      "poi_longitude": "-79.1111514",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 919-245-1956",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1512-4ee9-7423-a9b8-c1583413c1a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-4ee9-7423-a9b8-c1583413c1a8",
        "storage_key": "property/5656427712479232/019f1512-4ee9-7423-a9b8-c1583413c1a8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdUp3H9XYrIkRtk-bIavG-EM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "ec_a27452e63b0f547e21f838a1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "El Restaurante Ixtapa",
      "poi_type": "Restaurants",
      "poi_address": "162 Exchange Park Ln, Hillsborough, NC 27278, USA",
      "poi_short_description": "Unfussy eatery serving Mexican fare, including handmade tortillas & fruit juices, in a cozy space.",
      "poi_long_description": "Unfussy eatery serving Mexican fare, including handmade tortillas & fruit juices, in a cozy space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1511-a472-749c-8d27-2e58590ed69e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-a472-749c-8d27-2e58590ed69e",
        "storage_key": "property/5656427712479232/019f1511-a472-749c-8d27-2e58590ed69e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://ixtapa.homestead.com/homepage.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=5381109095568190165&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "el-restaurante-ixtapa",
      "poi_latitude": "36.0719061",
      "poi_longitude": "-79.1007387",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 919-644-6944",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-d26a-777b-a0ed-32aad62790e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-d26a-777b-a0ed-32aad62790e5",
        "storage_key": "property/5656427712479232/019f150f-d26a-777b-a0ed-32aad62790e5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJhSge5SjfrIkR1Sr3SjaKrUo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_89b94fb62f57a758230841a5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "Big Bob's City Grill",
      "poi_type": "Restaurants",
      "poi_address": "584 Cornelius St, Hillsborough, NC 27278, USA",
      "poi_short_description": "Home-cooking eatery for burgers and fried favorites, plus fish plates and chicken tenders.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1511-a09f-7722-b5ab-7c097814486c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-a09f-7722-b5ab-7c097814486c",
        "storage_key": "property/5656427712479232/019f1511-a09f-7722-b5ab-7c097814486c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://m.facebook.com/pages/Big-Bobs-City-Grill/120738204604586",
      "poi_directions_map_url": "https://maps.google.com/?cid=12737920726270469125&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "big-bobs-city-grill",
      "poi_latitude": "36.0867386",
      "poi_longitude": "-79.1120521",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 919-732-2953",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-d26a-777b-a0ed-32aad62790e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-d26a-777b-a0ed-32aad62790e5",
        "storage_key": "property/5656427712479232/019f150f-d26a-777b-a0ed-32aad62790e5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJB8XACsvYrIkRBeRvgmkvxrA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_537601d489b1543fc1ab898e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "Willie’s Pizzeria and Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "670 N Churton St, Hillsborough, NC 27278, USA",
      "poi_short_description": "Casual eatery for pizzas and Italian eats, with salads and burgers, plus beer and wine.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1511-98c1-71c6-8747-3a39d13177d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-98c1-71c6-8747-3a39d13177d9",
        "storage_key": "property/5656427712479232/019f1511-98c1-71c6-8747-3a39d13177d9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.williespizzeriaandrestaurant.com/?utm_source=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=17447843600147101849&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "willies-pizzeria-and-restaurant",
      "poi_latitude": "36.08551",
      "poi_longitude": "-79.09922",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 919-245-1900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-d26a-777b-a0ed-32aad62790e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-d26a-777b-a0ed-32aad62790e5",
        "storage_key": "property/5656427712479232/019f150f-d26a-777b-a0ed-32aad62790e5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8UrwjRvfrIkRmThXy08xI_I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_25aa63a75a7e44102ec568be",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "Eno River Brewing",
      "poi_type": "Restaurants",
      "poi_address": "329 Eno Mountain Rd, Hillsborough, NC 27278, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1511-a730-7540-9ffa-b9a4c3e7da20.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-a730-7540-9ffa-b9a4c3e7da20",
        "storage_key": "property/5656427712479232/019f1511-a730-7540-9ffa-b9a4c3e7da20.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.enoriverbrewing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14126748361464678069&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eno-river-brewing",
      "poi_latitude": "36.06880719999999",
      "poi_longitude": "-79.11427809999999",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 919-241-4711",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-d276-7299-865c-5eb5f74e8236.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-d276-7299-865c-5eb5f74e8236",
        "storage_key": "property/5656427712479232/019f150f-d276-7299-865c-5eb5f74e8236.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-Y8gPU3ZrIkRtQZvvMlKDMQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewery"
    },
    {
      "id": "ec_a51469c8450d4150f65d1a1d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "Village Diner",
      "poi_type": "Restaurants",
      "poi_address": "600 W King St, Hillsborough, NC 27278, USA",
      "poi_short_description": "Southern & American country cooking featuring local & seasonal ingredients in a homey setting.",
      "poi_long_description": "Southern & American country cooking featuring local & seasonal ingredients in a homey setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1511-a6e3-75df-b5ef-7d900c054f2e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-a6e3-75df-b5ef-7d900c054f2e",
        "storage_key": "property/5656427712479232/019f1511-a6e3-75df-b5ef-7d900c054f2e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://villagedinernc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3171774246551012055&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "village-diner",
      "poi_latitude": "36.0755693",
      "poi_longitude": "-79.1160457",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 919-245-8915",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-d26a-777b-a0ed-32aad62790e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-d26a-777b-a0ed-32aad62790e5",
        "storage_key": "property/5656427712479232/019f150f-d26a-777b-a0ed-32aad62790e5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJnwPb_9PYrIkR18JnWd9nBCw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_474a3d1dbb84b9333fabcf23",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "Pueblo Viejo Mexican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "370 S Churton St, Hillsborough, NC 27278, USA",
      "poi_short_description": "A menu featuring an array of classic Mexican fare in an easygoing setting with bar & table seating.",
      "poi_long_description": "A menu featuring an array of classic Mexican fare in an easygoing setting with bar & table seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1511-addc-730f-9dea-cfb42db328fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-addc-730f-9dea-cfb42db328fe",
        "storage_key": "property/5656427712479232/019f1511-addc-730f-9dea-cfb42db328fe.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://www.puebloviejohillsboroughnc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6171855772458650303&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pueblo-viejo-mexican-restaurant",
      "poi_latitude": "36.058626",
      "poi_longitude": "-79.1041245",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 919-732-3480",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-d26a-777b-a0ed-32aad62790e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-d26a-777b-a0ed-32aad62790e5",
        "storage_key": "property/5656427712479232/019f150f-d26a-777b-a0ed-32aad62790e5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJn-xeay_frIkRv4pXCiDWplU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_f8c27717bd81c96e216902a9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "Wooden Nickel Pub - Hillsborough",
      "poi_type": "Restaurants",
      "poi_address": "113 N Churton St, Hillsborough, NC 27278, USA",
      "poi_short_description": "Chill neighborhood nook providing jumbo wings & an array of sauces along with lots of craft beers.",
      "poi_long_description": "Chill neighborhood nook providing jumbo wings & an array of sauces along with lots of craft beers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1511-ae2b-723a-96e4-472711025e8e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-ae2b-723a-96e4-472711025e8e",
        "storage_key": "property/5656427712479232/019f1511-ae2b-723a-96e4-472711025e8e.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.thewnp.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2722988040028319995&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wooden-nickel-pub---hillsborough",
      "poi_latitude": "36.0758143",
      "poi_longitude": "-79.0996229",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 919-932-0134",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1512-4ee9-7423-a9b8-c1583413c1a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-4ee9-7423-a9b8-c1583413c1a8",
        "storage_key": "property/5656427712479232/019f1512-4ee9-7423-a9b8-c1583413c1a8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeZh_bi_frIkR-3CGBTL_ySU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pub"
    },
    {
      "id": "ec_202227a88d73e3d77d24bb81",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "Cup-A-Joe",
      "poi_type": "Restaurants",
      "poi_address": "112 W King St, Hillsborough, NC 27278, USA",
      "poi_short_description": "Chill coffeehouse with rotating beans, light bites & sweet treats, plus local art & outdoor seating.",
      "poi_long_description": "Chill coffeehouse with rotating beans, light bites & sweet treats, plus local art & outdoor seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1511-b868-70cd-b36d-49d60eb1a99b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-b868-70cd-b36d-49d60eb1a99b",
        "storage_key": "property/5656427712479232/019f1511-b868-70cd-b36d-49d60eb1a99b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.hboro-cupajoe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14446834818758204032&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cup-a-joe",
      "poi_latitude": "36.0755341",
      "poi_longitude": "-79.0999457",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 223-380-2263",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1512-4ee5-72bd-81f7-eed7b23ea558.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-4ee5-72bd-81f7-eed7b23ea558",
        "storage_key": "property/5656427712479232/019f1512-4ee5-72bd-81f7-eed7b23ea558.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ7f7HFi_frIkRgNrTnLl3fcg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_c07baa214a01762f00b81b23",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "Weaver Street Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "228 S Churton St Ste 200 (second floor, Hillsborough, NC 27278, USA",
      "poi_short_description": "Community-owned grocery store offering organic products, prepared foods, and a salad bar, plus a cafe, and a bakery.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-5694-74b3-94b0-e8243194c0bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-5694-74b3-94b0-e8243194c0bb",
        "storage_key": "property/5656427712479232/019f150f-5694-74b3-94b0-e8243194c0bb.webp",
        "width": 1024,
        "height": 452
      },
      "poi_business_url": "http://www.weaverstreetmarket.coop/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4570515170774937194&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "weaver-street-market",
      "poi_latitude": "36.0734183",
      "poi_longitude": "-79.0995745",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 919-245-5050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-d274-7061-84af-654407ee2ea1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-d274-7061-84af-654407ee2ea1",
        "storage_key": "property/5656427712479232/019f150f-d274-7061-84af-654407ee2ea1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmzfEsyjfrIkRau6SClW7bT8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_2eadc588489650e2456295af",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "Food Lion",
      "poi_type": "Shopping & Retail",
      "poi_address": "101 N Scotswood Blvd, Hillsborough, NC 27278, USA",
      "poi_short_description": "Grocery chain in the Churton Grove Center offering prepared foods, organic products, and bulk options.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1511-c170-7563-a27b-7faf25d08c6d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-c170-7563-a27b-7faf25d08c6d",
        "storage_key": "property/5656427712479232/019f1511-c170-7563-a27b-7faf25d08c6d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.foodlion.com/nc/hillsborough/101-n-scotswood-blvd?y_source=1_NTA0Njk1Ny03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=11957814313275769526&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "food-lion",
      "poi_latitude": "36.083531",
      "poi_longitude": "-79.0796676",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 919-732-5964",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-d274-7061-84af-654407ee2ea1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-d274-7061-84af-654407ee2ea1",
        "storage_key": "property/5656427712479232/019f150f-d274-7061-84af-654407ee2ea1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvYVQ7hPfrIkRtkLiQMOw8qU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_4f1a4978a9f3e8e5a2473aa7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "2010 NC-86, Hillsborough, NC 27278, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-5f94-75ff-bd21-22b8f9d0206e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-5f94-75ff-bd21-22b8f9d0206e",
        "storage_key": "property/5656427712479232/019f150f-5f94-75ff-bd21-22b8f9d0206e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://info.aldi.us/stores/l/nc/hillsborough/2010-nc-hwy-86-south/f983",
      "poi_directions_map_url": "https://maps.google.com/?cid=10908678899336637522&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "36.05576",
      "poi_longitude": "-79.07964",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-d274-7061-84af-654407ee2ea1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-d274-7061-84af-654407ee2ea1",
        "storage_key": "property/5656427712479232/019f150f-d274-7061-84af-654407ee2ea1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsdMNCADfrIkRUmzCi6lpY5c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "ec_af5b1a061401ad96f51f190d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "200 US-70, Hillsborough, NC 27278, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1511-c7fa-779b-831c-7366877b4167.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-c7fa-779b-831c-7366877b4167",
        "storage_key": "property/5656427712479232/019f1511-c7fa-779b-831c-7366877b4167.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-200+us+highway+70+e-hillsborough-nc-27278/id=16128",
      "poi_directions_map_url": "https://maps.google.com/?cid=7492712944167429935&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "36.086758",
      "poi_longitude": "-79.0990906",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 919-732-6263",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1512-4ee8-773d-b408-408a107f29d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-4ee8-773d-b408-408a107f29d8",
        "storage_key": "property/5656427712479232/019f1512-4ee8-773d-b408-408a107f29d8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhaGgcDffrIkRLycSgbl2-2c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_96e0bd3574a32f242a8374b0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "Dollar General",
      "poi_type": "Shopping & Retail",
      "poi_address": "662 N Churton St, Hillsborough, NC 27278, USA",
      "poi_short_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_long_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1511-bb74-77c4-9109-bdb54d9931a9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-bb74-77c4-9109-bdb54d9931a9",
        "storage_key": "property/5656427712479232/019f1511-bb74-77c4-9109-bdb54d9931a9.webp",
        "width": 480,
        "height": 720
      },
      "poi_business_url": "https://www.dollargeneral.com/store-directory/nc/hillsborough/4034",
      "poi_directions_map_url": "https://maps.google.com/?cid=11513354529166256100&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-general",
      "poi_latitude": "36.0853176",
      "poi_longitude": "-79.0990578",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 919-296-4079",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-d2ce-749a-b13d-b160120f3d8c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-d2ce-749a-b13d-b160120f3d8c",
        "storage_key": "property/5656427712479232/019f150f-d2ce-749a-b13d-b160120f3d8c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJNdCnITffrIkR5OcWpPGmx58",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "ec_65365d09fbfbb9e87f4b1622",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "B & B Produce",
      "poi_type": "Shopping & Retail",
      "poi_address": "2778 NC-50, Benson, NC 27504, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1511-c7a7-74df-b310-341ffdbae52e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-c7a7-74df-b310-341ffdbae52e",
        "storage_key": "property/5656427712479232/019f1511-c7a7-74df-b310-341ffdbae52e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://bandbproduce.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13130587542639342644&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "b--b-produce",
      "poi_latitude": "35.3639714",
      "poi_longitude": "-78.51214499999999",
      "poi_miles_from_property": "69.3 mi",
      "poi_walking_minutes": "1 day 1 hour",
      "poi_biking_minutes": "6 hours 22 mins",
      "poi_driving_minutes": "1 hour 9 mins",
      "poi_business_phone": "+1 919-894-2527",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-d274-7061-84af-654407ee2ea1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-d274-7061-84af-654407ee2ea1",
        "storage_key": "property/5656427712479232/019f150f-d274-7061-84af-654407ee2ea1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAxEWU4aHq4kRNPQvG803ObY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_3a3244d0b591e199d3b123b0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "The Shops At Daniel Boone",
      "poi_type": "Shopping & Retail",
      "poi_address": "Hillsborough, NC 27278, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=15270665496112100633&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-shops-at-daniel-boone",
      "poi_latitude": "36.0581448",
      "poi_longitude": "-79.1031162",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-d2ce-749a-b13d-b160120f3d8c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-d2ce-749a-b13d-b160120f3d8c",
        "storage_key": "property/5656427712479232/019f150f-d2ce-749a-b13d-b160120f3d8c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJzdG9_UXfrIkRGXWTe1xN7NM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "ec_cc0d73ea88f85ffec3c1b8a2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "North Hills Shopping Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "660 N Churton St, Hillsborough, NC 27278, USA",
      "poi_short_description": "Business center featuring multiple shops and a pool hall, plus a popular pizza restaurant.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1511-bdd6-75f8-8ece-b9cce01944b7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-bdd6-75f8-8ece-b9cce01944b7",
        "storage_key": "property/5656427712479232/019f1511-bdd6-75f8-8ece-b9cce01944b7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://north-hills.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7516512464476472017&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-hills-shopping-center",
      "poi_latitude": "36.08507549999999",
      "poi_longitude": "-79.09898",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 919-669-1889",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-d276-7299-865c-5eb5f74e8236.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-d276-7299-865c-5eb5f74e8236",
        "storage_key": "property/5656427712479232/019f150f-d276-7299-865c-5eb5f74e8236.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj8tVWzffrIkR0YLqIkMEUGg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "business_center"
    },
    {
      "id": "ec_826f9e3d6a212d7de357bfd3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "North Hills Shopping Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "660 N Churton St, Hillsborough, NC 27278, USA",
      "poi_short_description": "Business center featuring multiple shops and a pool hall, plus a popular pizza restaurant.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1511-be33-71d2-8074-24073859f0af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-be33-71d2-8074-24073859f0af",
        "storage_key": "property/5656427712479232/019f1511-be33-71d2-8074-24073859f0af.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://north-hills.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7516512464476472017&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-hills-shopping-center",
      "poi_latitude": "36.08507549999999",
      "poi_longitude": "-79.09898",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 919-669-1889",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-d276-7299-865c-5eb5f74e8236.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-d276-7299-865c-5eb5f74e8236",
        "storage_key": "property/5656427712479232/019f150f-d276-7299-865c-5eb5f74e8236.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj8tVWzffrIkR0YLqIkMEUGg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "business_center"
    },
    {
      "id": "ec_4b5cfeaa66879d0e99819785",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "Hillsborough Elementary School",
      "poi_type": "Education",
      "poi_address": "402 N Nash St, Hillsborough, NC 27278, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1511-ceb6-774e-aa1f-e0d7916b12a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-ceb6-774e-aa1f-e0d7916b12a5",
        "storage_key": "property/5656427712479232/019f1511-ceb6-774e-aa1f-e0d7916b12a5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://hes.orangecountyfirst.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7298986881512250730&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hillsborough-elementary-school",
      "poi_latitude": "36.0804443",
      "poi_longitude": "-79.11035319999999",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 919-732-6137",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-d26f-73cf-8784-54a7a51dd1f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-d26f-73cf-8784-54a7a51dd1f6",
        "storage_key": "property/5656427712479232/019f150f-d26f-73cf-8784-54a7a51dd1f6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJMeHRYc3YrIkRah3GpOU1S2U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_5c4ab123109b1677d5a8a8e6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "Central Elementary School",
      "poi_type": "Education",
      "poi_address": "154 Hayes St, Hillsborough, NC 27278, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1511-d028-7132-bbb1-7037dc851ea0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-d028-7132-bbb1-7037dc851ea0",
        "storage_key": "property/5656427712479232/019f1511-d028-7132-bbb1-7037dc851ea0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.orangecountyfirst.com/ce",
      "poi_directions_map_url": "https://maps.google.com/?cid=4971996208476238012&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "central-elementary-school",
      "poi_latitude": "36.08001369999999",
      "poi_longitude": "-79.114831",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 919-732-3622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-d26f-73cf-8784-54a7a51dd1f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-d26f-73cf-8784-54a7a51dd1f6",
        "storage_key": "property/5656427712479232/019f150f-d26f-73cf-8784-54a7a51dd1f6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJWU_zF9LYrIkRvLDQdjUUAEU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_06adc015e7b91b38d7bfdad6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "River Park Elementary School",
      "poi_type": "Education",
      "poi_address": "240 St Marys Rd, Hillsborough, NC 27278, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1511-c864-74f8-b865-bfd9240da3f0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-c864-74f8-b865-bfd9240da3f0",
        "storage_key": "property/5656427712479232/019f1511-c864-74f8-b865-bfd9240da3f0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://rpes.orangecountyfirst.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=80210523795005543&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "river-park-elementary-school",
      "poi_latitude": "36.0762767",
      "poi_longitude": "-79.09336619999999",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 919-732-9326",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-d26f-73cf-8784-54a7a51dd1f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-d26f-73cf-8784-54a7a51dd1f6",
        "storage_key": "property/5656427712479232/019f150f-d26f-73cf-8784-54a7a51dd1f6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkYRGmCTfrIkRZ6AM4gv3HAE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_7b5c3cb3ec391cc13f4d515e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "Grady Brown Elementary School",
      "poi_type": "Education",
      "poi_address": "1100 New Grady Brown School Rd, Hillsborough, NC 27278, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1511-c808-7516-9753-1aa9e3d6b9b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-c808-7516-9753-1aa9e3d6b9b2",
        "storage_key": "property/5656427712479232/019f1511-c808-7516-9753-1aa9e3d6b9b2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://orangecountyfirst.com/Page/19",
      "poi_directions_map_url": "https://maps.google.com/?cid=2524169255176812759&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grady-brown-elementary-school",
      "poi_latitude": "36.0516624",
      "poi_longitude": "-79.1269959",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 919-732-6138",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-d26f-73cf-8784-54a7a51dd1f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-d26f-73cf-8784-54a7a51dd1f6",
        "storage_key": "property/5656427712479232/019f150f-d26f-73cf-8784-54a7a51dd1f6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ8TP__TjZrIkR17jGX5CmByM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_9a170a1a55555c7526125173",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "Pathways Elementary School",
      "poi_type": "Education",
      "poi_address": "431 Strouds Creek Rd, Hillsborough, NC 27278, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://pes.orangecountyfirst.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8021895278454473076&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pathways-elementary-school",
      "poi_latitude": "36.1107178",
      "poi_longitude": "-79.10380459999999",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 919-732-9136",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-d26f-73cf-8784-54a7a51dd1f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-d26f-73cf-8784-54a7a51dd1f6",
        "storage_key": "property/5656427712479232/019f150f-d26f-73cf-8784-54a7a51dd1f6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJW-za4akgrYkRdIGpAUF_U28",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_45f8a3280fa31182ca0641a2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "A. L. Stanback Middle School",
      "poi_type": "Education",
      "poi_address": "3700 NC-86, Hillsborough, NC 27278, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.orangecountyfirst.com/als",
      "poi_directions_map_url": "https://maps.google.com/?cid=2647067303170702610&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "a-l-stanback-middle-school",
      "poi_latitude": "36.0272808",
      "poi_longitude": "-79.0783901",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 919-644-3200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-d26f-73cf-8784-54a7a51dd1f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-d26f-73cf-8784-54a7a51dd1f6",
        "storage_key": "property/5656427712479232/019f150f-d26f-73cf-8784-54a7a51dd1f6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJMTcL1-zerIkREn0K_q9FvCQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_a6ce28562013d9b0e244f6dc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "Orange High School",
      "poi_type": "Education",
      "poi_address": "500 Orange High School Rd, Hillsborough, NC 27278, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1511-db34-7292-8d67-af4de593b582.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-db34-7292-8d67-af4de593b582",
        "storage_key": "property/5656427712479232/019f1511-db34-7292-8d67-af4de593b582.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.orangecountyfirst.com/ohs",
      "poi_directions_map_url": "https://maps.google.com/?cid=1656411410485702776&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orange-high-school",
      "poi_latitude": "36.0927188",
      "poi_longitude": "-79.09413239999999",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 919-732-6133",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-d26f-73cf-8784-54a7a51dd1f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-d26f-73cf-8784-54a7a51dd1f6",
        "storage_key": "property/5656427712479232/019f150f-d26f-73cf-8784-54a7a51dd1f6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJU5H000bfrIkReHDn22bB_BY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_4be10ac260eeb79e69b34d2b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "Cedar Ridge High School",
      "poi_type": "Education",
      "poi_address": "1125 New Grady Brown School Rd, Hillsborough, NC 27278, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1511-d932-77c1-a647-b0d97de65140.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-d932-77c1-a647-b0d97de65140",
        "storage_key": "property/5656427712479232/019f1511-d932-77c1-a647-b0d97de65140.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.orangecountyfirst.com/crhs",
      "poi_directions_map_url": "https://maps.google.com/?cid=2670134066012225929&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cedar-ridge-high-school",
      "poi_latitude": "36.0535062",
      "poi_longitude": "-79.1264455",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 919-245-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-d26f-73cf-8784-54a7a51dd1f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-d26f-73cf-8784-54a7a51dd1f6",
        "storage_key": "property/5656427712479232/019f150f-d26f-73cf-8784-54a7a51dd1f6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ5RbFLDnZrIkRiQFUO8k4DiU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_dbf8727bdb081f3500971fe5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "Little School of Hillsborough",
      "poi_type": "Education",
      "poi_address": "301 College Park Rd, Hillsborough, NC 27278, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-7b14-7432-be72-56db8f47691a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-7b14-7432-be72-56db8f47691a",
        "storage_key": "property/5656427712479232/019f150f-7b14-7432-be72-56db8f47691a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.thelittleschool.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16248536433435067365&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "little-school-of-hillsborough",
      "poi_latitude": "36.0448608",
      "poi_longitude": "-79.0924453",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 919-644-1818",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-d26f-73cf-8784-54a7a51dd1f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-d26f-73cf-8784-54a7a51dd1f6",
        "storage_key": "property/5656427712479232/019f150f-d26f-73cf-8784-54a7a51dd1f6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJUbQ7WrnerIkR5cPjOsxlfuE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_7c268f1076f136393af72235",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "Durham Tech Community College Orange County Campus",
      "poi_type": "Education",
      "poi_address": "525 College Park Rd, Hillsborough, NC 27278, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-7511-733c-a210-91c63d305636.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-7511-733c-a210-91c63d305636",
        "storage_key": "property/5656427712479232/019f150f-7511-733c-a210-91c63d305636.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.durhamtech.edu/orange-county-campus",
      "poi_directions_map_url": "https://maps.google.com/?cid=16936686267357057451&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "durham-tech-community-college-orange-county-campus",
      "poi_latitude": "36.04103",
      "poi_longitude": "-79.09288699999999",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 919-536-7238",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-d26f-73cf-8784-54a7a51dd1f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-d26f-73cf-8784-54a7a51dd1f6",
        "storage_key": "property/5656427712479232/019f150f-d26f-73cf-8784-54a7a51dd1f6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJLSXBVLnerIkRq9EN_mwyC-s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_3dcd02e0c467974a3ea2d713",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "Hillsborough Gallery of Arts",
      "poi_type": "Entertainment",
      "poi_address": "121 N Churton St, Hillsborough, NC 27278, USA",
      "poi_short_description": "Neighborhood gallery featuring the work of local artists, with free admission.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1511-e21f-77bf-8f6b-159b1899dcda.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-e21f-77bf-8f6b-159b1899dcda",
        "storage_key": "property/5656427712479232/019f1511-e21f-77bf-8f6b-159b1899dcda.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://hillsboroughgallery.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7516188982004894127&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hillsborough-gallery-of-arts",
      "poi_latitude": "36.0760991",
      "poi_longitude": "-79.0997261",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 919-732-5001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-d276-7299-865c-5eb5f74e8236.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-d276-7299-865c-5eb5f74e8236",
        "storage_key": "property/5656427712479232/019f150f-d276-7299-865c-5eb5f74e8236.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9T__nS_frIkRr0kbgQ7eTmg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_gallery"
    },
    {
      "id": "ec_488aa8e1f3e983fa012a34b9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "Eno River Brewing",
      "poi_type": "Entertainment",
      "poi_address": "329 Eno Mountain Rd, Hillsborough, NC 27278, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1511-a730-7540-9ffa-b9a4c3e7da20.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-a730-7540-9ffa-b9a4c3e7da20",
        "storage_key": "property/5656427712479232/019f1511-a730-7540-9ffa-b9a4c3e7da20.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.enoriverbrewing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14126748361464678069&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eno-river-brewing",
      "poi_latitude": "36.06880719999999",
      "poi_longitude": "-79.11427809999999",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 919-241-4711",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-d276-7299-865c-5eb5f74e8236.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-d276-7299-865c-5eb5f74e8236",
        "storage_key": "property/5656427712479232/019f150f-d276-7299-865c-5eb5f74e8236.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-Y8gPU3ZrIkRtQZvvMlKDMQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewery"
    },
    {
      "id": "ec_5b84b119380e7809a3489fcd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "Nash Street Tavern",
      "poi_type": "Entertainment",
      "poi_address": "250 S Nash St, Hillsborough, NC 27278, USA",
      "poi_short_description": "Casual watering hole with live music on weekends, plus bar games and outdoor seating.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1511-a16a-747f-a509-a70f36f650d5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-a16a-747f-a509-a70f36f650d5",
        "storage_key": "property/5656427712479232/019f1511-a16a-747f-a509-a70f36f650d5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.facebook.com/NashStreetTavern/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4897883033070948278&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nash-street-tavern",
      "poi_latitude": "36.0719266",
      "poi_longitude": "-79.1111514",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 919-245-1956",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1512-4ee9-7423-a9b8-c1583413c1a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-4ee9-7423-a9b8-c1583413c1a8",
        "storage_key": "property/5656427712479232/019f1512-4ee9-7423-a9b8-c1583413c1a8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdUp3H9XYrIkRtk-bIavG-EM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "ec_967465926c8e8d324eff39e9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "Yonder: Southern Cocktails and Brew",
      "poi_type": "Entertainment",
      "poi_address": "114 W King St, Hillsborough, NC 27278, USA",
      "poi_short_description": "Comfortable bar for craft cocktails and live local music with a comfy vibe.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1511-e2fe-727b-a8b2-695d6e79f39f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-e2fe-727b-a8b2-695d6e79f39f",
        "storage_key": "property/5656427712479232/019f1511-e2fe-727b-a8b2-695d6e79f39f.webp",
        "width": 960,
        "height": 960
      },
      "poi_business_url": "http://yonderbarnc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4163404104033877651&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "yonder-southern-cocktails-and-brew",
      "poi_latitude": "36.0754877",
      "poi_longitude": "-79.10003139999999",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 919-283-2368",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1512-4ee9-7423-a9b8-c1583413c1a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-4ee9-7423-a9b8-c1583413c1a8",
        "storage_key": "property/5656427712479232/019f1512-4ee9-7423-a9b8-c1583413c1a8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyTNYT5LfrIkRk75XVflhxzk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "ec_d75ecfb58fa8ec26c933ea4e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "Burwell School Historic Site",
      "poi_type": "Entertainment",
      "poi_address": "319 N Churton St, Hillsborough, NC 27278, USA",
      "poi_short_description": "Preserved antebellum house that was once a girls' school offers self-guided and docent-led tours.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1511-fd83-77c4-a709-90582df543b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-fd83-77c4-a709-90582df543b5",
        "storage_key": "property/5656427712479232/019f1511-fd83-77c4-a709-90582df543b5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.burwellschool.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12867455252018076407&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "burwell-school-historic-site",
      "poi_latitude": "36.0801756",
      "poi_longitude": "-79.1005552",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 919-732-7451",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-d288-71ff-a250-54b4b6f9df2f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-d288-71ff-a250-54b4b6f9df2f",
        "storage_key": "property/5656427712479232/019f150f-d288-71ff-a250-54b4b6f9df2f.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJCTvgGDDfrIkR95rFg2BikrI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_a01625dc4508217407850aef",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "Gold Park",
      "poi_type": "Entertainment",
      "poi_address": "415 Dimmocks Mill Rd, Hillsborough, NC 27278, USA",
      "poi_short_description": "Popular park, featuring a soccer field, playground, dog park and picnic shelters.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1511-fe5b-7548-9d9b-d5b726340c7e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-fe5b-7548-9d9b-d5b726340c7e",
        "storage_key": "property/5656427712479232/019f1511-fe5b-7548-9d9b-d5b726340c7e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://visithillsboroughnc.com/things-to-do/gold-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8084195782526240324&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gold-park",
      "poi_latitude": "36.0709326",
      "poi_longitude": "-79.1103703",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 919-732-1270",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-d289-70d5-ac85-6a99a41099fe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-d289-70d5-ac85-6a99a41099fe",
        "storage_key": "property/5656427712479232/019f150f-d289-70d5-ac85-6a99a41099fe.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9aYTWdXYrIkRRAYweDvVMHA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_107c0cbb405b54ccdee29351",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "The ArtsCenter",
      "poi_type": "Entertainment",
      "poi_address": "400 Roberson St, Carrboro, NC 27510, USA",
      "poi_short_description": "Venue for concerts, theater, family programs & visual art exhibits, with classes & children's camps.",
      "poi_long_description": "Venue for concerts, theater, family programs & visual art exhibits, with classes & children's camps.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1511-f559-72b7-a8b0-5d2717096dd8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-f559-72b7-a8b0-5d2717096dd8",
        "storage_key": "property/5656427712479232/019f1511-f559-72b7-a8b0-5d2717096dd8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.artscenterlive.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7028440541182195952&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-artscenter",
      "poi_latitude": "35.9096051",
      "poi_longitude": "-79.0698824",
      "poi_miles_from_property": "11.4 mi",
      "poi_walking_minutes": "4 hours 7 mins",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 919-929-2787",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-d276-7299-865c-5eb5f74e8236.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-d276-7299-865c-5eb5f74e8236",
        "storage_key": "property/5656427712479232/019f150f-d276-7299-865c-5eb5f74e8236.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd27Voh7DrIkR8HgeFm8JimE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_8b8dbd8b622b7b5dd91b73d9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "Morehead Planetarium and Science Center",
      "poi_type": "Entertainment",
      "poi_address": "250 E Franklin St, Chapel Hill, NC 27514, USA",
      "poi_short_description": "68-ft.-tall campus planetarium & science center with exhibits, shows & classes open to the public.",
      "poi_long_description": "68-ft.-tall campus planetarium & science center with exhibits, shows & classes open to the public.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1511-e9a5-739e-b34c-a8da689fa621.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-e9a5-739e-b34c-a8da689fa621",
        "storage_key": "property/5656427712479232/019f1511-e9a5-739e-b34c-a8da689fa621.webp",
        "width": 1200,
        "height": 821
      },
      "poi_business_url": "http://www.moreheadplanetarium.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10304209357348446092&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "morehead-planetarium-and-science-center",
      "poi_latitude": "35.9139033",
      "poi_longitude": "-79.05051",
      "poi_miles_from_property": "10.6 mi",
      "poi_walking_minutes": "3 hours 52 mins",
      "poi_biking_minutes": "1 hour 10 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 919-962-1236",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-d26f-73cf-8784-54a7a51dd1f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-d26f-73cf-8784-54a7a51dd1f6",
        "storage_key": "property/5656427712479232/019f150f-d26f-73cf-8784-54a7a51dd1f6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJg7XHlMLCrIkRjJ8CBNHn_44",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "planetarium"
    },
    {
      "id": "ec_8b6d299608a149d609fae8ad",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "Durham Performing Arts Center",
      "poi_type": "Entertainment",
      "poi_address": "123 William V Bill Bell Wy, Durham, NC 27701, USA",
      "poi_short_description": "Modern, multilevel theater showcasing recent Broadway shows & well-known music artists.",
      "poi_long_description": "Modern, multilevel theater showcasing recent Broadway shows & well-known music artists.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1511-edeb-75a8-9df3-22ae18b774aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-edeb-75a8-9df3-22ae18b774aa",
        "storage_key": "property/5656427712479232/019f1511-edeb-75a8-9df3-22ae18b774aa.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.dpacnc.com/home",
      "poi_directions_map_url": "https://maps.google.com/?cid=14008075325458362087&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "durham-performing-arts-center",
      "poi_latitude": "35.993248",
      "poi_longitude": "-78.9021923",
      "poi_miles_from_property": "14.4 mi",
      "poi_walking_minutes": "5 hours 12 mins",
      "poi_biking_minutes": "1 hour 14 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 919-680-2787",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-d276-7299-865c-5eb5f74e8236.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-d276-7299-865c-5eb5f74e8236",
        "storage_key": "property/5656427712479232/019f150f-d276-7299-865c-5eb5f74e8236.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu-ZMSWzkrIkR5y7cYEquZsI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_ac093d523b38ba3639192d83",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "Museum of Life and Science",
      "poi_type": "Entertainment",
      "poi_address": "433 W Murray Ave, Durham, NC 27704, USA",
      "poi_short_description": "Indoor & outdoor museum with interactive exhibits on space exploration & life on earth.",
      "poi_long_description": "Indoor & outdoor museum with interactive exhibits on space exploration & life on earth.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1512-0630-72c5-8a87-9b6e04f0951c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-0630-72c5-8a87-9b6e04f0951c",
        "storage_key": "property/5656427712479232/019f1512-0630-72c5-8a87-9b6e04f0951c.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://lifeandscience.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18376687830596889048&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "museum-of-life-and-science",
      "poi_latitude": "36.0293716",
      "poi_longitude": "-78.89944609999999",
      "poi_miles_from_property": "14.5 mi",
      "poi_walking_minutes": "5 hours 14 mins",
      "poi_biking_minutes": "1 hour 17 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 919-220-5429",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-d288-71ff-a250-54b4b6f9df2f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-d288-71ff-a250-54b4b6f9df2f",
        "storage_key": "property/5656427712479232/019f150f-d288-71ff-a250-54b4b6f9df2f.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJKWHRe73jrIkR2Kn40jccB_8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_406cfa7ad1a51c095f2705e1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "UNC Hospitals Hillsborough Campus",
      "poi_type": "Health and Wellness",
      "poi_address": "430 Waterstone Dr, Hillsborough, NC 27278, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-a2ca-7658-b2a2-5c0446c85da6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-a2ca-7658-b2a2-5c0446c85da6",
        "storage_key": "property/5656427712479232/019f150f-a2ca-7658-b2a2-5c0446c85da6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.unchealth.org/care-services/locations/unc-hospitals-hillsborough-campus",
      "poi_directions_map_url": "https://maps.google.com/?cid=17974344110273538099&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "unc-hospitals-hillsborough-campus",
      "poi_latitude": "36.0368391",
      "poi_longitude": "-79.0909186",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 984-215-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-d292-751a-81cc-dea852d419e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-d292-751a-81cc-dea852d419e8",
        "storage_key": "property/5656427712479232/019f150f-d292-751a-81cc-dea852d419e8.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJJT4Nw7zerIkRMyh9c7yycfk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_fd2bf81817954c27c89268ec",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "UNC Urgent Care at Hillsborough",
      "poi_type": "Health and Wellness",
      "poi_address": "2800 Old NC 86 Ste 100, Hillsborough, NC 27278, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1511-f118-725c-b65c-07c9219d1841.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-f118-725c-b65c-07c9219d1841",
        "storage_key": "property/5656427712479232/019f1511-f118-725c-b65c-07c9219d1841.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.unchealth.org/care-services/locations/unc-urgent-care-at-hillsborough",
      "poi_directions_map_url": "https://maps.google.com/?cid=443264469970761595&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "unc-urgent-care-at-hillsborough",
      "poi_latitude": "36.0441446",
      "poi_longitude": "-79.0993847",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 984-215-5350",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-d276-7299-865c-5eb5f74e8236.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-d276-7299-865c-5eb5f74e8236",
        "storage_key": "property/5656427712479232/019f150f-d276-7299-865c-5eb5f74e8236.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz2m8k9DfrIkRe7co2q_KJgY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_812aee1b82507e82a51f1ed2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "Duke Urgent Care Hillsborough",
      "poi_type": "Health and Wellness",
      "poi_address": "267 S Churton St, Hillsborough, NC 27278, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1511-f628-757e-a851-6378c95e02db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-f628-757e-a851-6378c95e02db",
        "storage_key": "property/5656427712479232/019f1511-f628-757e-a851-6378c95e02db.webp",
        "width": 1080,
        "height": 310
      },
      "poi_business_url": "https://www.dukehealth.org/locations/duke-urgent-care-hillsborough?utm_source=google&utm_medium=local&utm_campaign=evergreen",
      "poi_directions_map_url": "https://maps.google.com/?cid=12871743948865934669&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "duke-urgent-care-hillsborough",
      "poi_latitude": "36.0642558",
      "poi_longitude": "-79.1002604",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 919-643-4511",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-d276-7299-865c-5eb5f74e8236.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-d276-7299-865c-5eb5f74e8236",
        "storage_key": "property/5656427712479232/019f150f-d276-7299-865c-5eb5f74e8236.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdw4R19berIkRTRXwj-yeobI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_ca986b6540584f3740e86ad0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "IndyCare Hillsborough",
      "poi_type": "Health and Wellness",
      "poi_address": "110 Boone Sq St #29A, Hillsborough, NC 27278, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1511-f815-7239-8dda-d7eefb28e76d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-f815-7239-8dda-d7eefb28e76d",
        "storage_key": "property/5656427712479232/019f1511-f815-7239-8dda-d7eefb28e76d.webp",
        "width": 679,
        "height": 381
      },
      "poi_business_url": "https://indycarehealth.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17482296401760564514&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "indycare-hillsborough",
      "poi_latitude": "36.0633573",
      "poi_longitude": "-79.10077849999999",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 919-245-1213",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-d276-7299-865c-5eb5f74e8236.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-d276-7299-865c-5eb5f74e8236",
        "storage_key": "property/5656427712479232/019f150f-d276-7299-865c-5eb5f74e8236.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5xxfSf7frIkRIjUHxfOXnfI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_e8f0273fa5781b24c0899b75",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "200 US-70, Hillsborough, NC 27278, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1511-c7fa-779b-831c-7366877b4167.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-c7fa-779b-831c-7366877b4167",
        "storage_key": "property/5656427712479232/019f1511-c7fa-779b-831c-7366877b4167.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-200+us+highway+70+e-hillsborough-nc-27278/id=16128",
      "poi_directions_map_url": "https://maps.google.com/?cid=7492712944167429935&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "36.086758",
      "poi_longitude": "-79.0990906",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 919-732-6263",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1512-4ee8-773d-b408-408a107f29d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-4ee8-773d-b408-408a107f29d8",
        "storage_key": "property/5656427712479232/019f1512-4ee8-773d-b408-408a107f29d8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhaGgcDffrIkRLycSgbl2-2c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_9b82a5e85509bd24f4c4516b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "Lloyd's Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "118 W King St, Hillsborough, NC 27278, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1512-0d7f-74f0-af8a-a3a6c2584034.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-0d7f-74f0-af8a-a3a6c2584034",
        "storage_key": "property/5656427712479232/019f1512-0d7f-74f0-af8a-a3a6c2584034.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://pharmacyhillsborough.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12851533551924423247&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lloyds-pharmacy",
      "poi_latitude": "36.0755401",
      "poi_longitude": "-79.10014939999999",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 919-732-1500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1512-4ee8-773d-b408-408a107f29d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-4ee8-773d-b408-408a107f29d8",
        "storage_key": "property/5656427712479232/019f1512-4ee8-773d-b408-408a107f29d8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo7a9Fi_frIkRTyp41azRWbI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_b462214c94ad6576a0e41b34",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "Hillsborough Pharmacy & Nutri",
      "poi_type": "Health and Wellness",
      "poi_address": "110 Boone Sq St, Hillsborough, NC 27278, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1512-061d-7508-abf1-462224663300.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-061d-7508-abf1-462224663300",
        "storage_key": "property/5656427712479232/019f1512-061d-7508-abf1-462224663300.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.hillsboroughpharmacync.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7994717402479457244&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hillsborough-pharmacy--nutri",
      "poi_latitude": "36.0633987",
      "poi_longitude": "-79.1009797",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 919-245-1212",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1512-4ee8-773d-b408-408a107f29d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-4ee8-773d-b408-408a107f29d8",
        "storage_key": "property/5656427712479232/019f1512-4ee8-773d-b408-408a107f29d8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn-xeay_frIkR3PNrph7x8m4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_1f125d75c6de5ace3e2390c7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "151 Mayo St, Hillsborough, NC 27278, USA",
      "poi_short_description": "Spacious, clean gym featuring equipment for cardio and weight training, plus hydro-massage beds and chairs, tanning and group training, as well as locker room facilities and showers.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-9069-75c9-a971-34cf1113efd4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-9069-75c9-a971-34cf1113efd4",
        "storage_key": "property/5656427712479232/019f150f-9069-75c9-a971-34cf1113efd4.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/hillsborough-nc?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=17992351373150874807&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "36.0612044",
      "poi_longitude": "-79.1062433",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 919-276-5331",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-d276-7299-865c-5eb5f74e8236.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-d276-7299-865c-5eb5f74e8236",
        "storage_key": "property/5656427712479232/019f150f-d276-7299-865c-5eb5f74e8236.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBwgCLNLerIkRt2yrDj-ssfk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_06f48ae9c6ef40a5af9f731e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "The Pit Unleashed",
      "poi_type": "Health and Wellness",
      "poi_address": "121 Boone Sq St, Hillsborough, NC 27278, USA",
      "poi_short_description": "Friendly, clean gym featuring 24-hour access plus free weights and cardio equipment.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-98b7-7711-aaaa-63946bdc219c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-98b7-7711-aaaa-63946bdc219c",
        "storage_key": "property/5656427712479232/019f150f-98b7-7711-aaaa-63946bdc219c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://thepitunleashed.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13176379007751054736&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-pit-unleashed",
      "poi_latitude": "36.0628429",
      "poi_longitude": "-79.0994837",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 336-442-1236",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-d276-7299-865c-5eb5f74e8236.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-d276-7299-865c-5eb5f74e8236",
        "storage_key": "property/5656427712479232/019f150f-d276-7299-865c-5eb5f74e8236.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2XVAJdferIkRkGXqZuXm27Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_a55e7ad20086da8f7285e0e1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "A Step To Health",
      "poi_type": "Health and Wellness",
      "poi_address": "410 Millstone Dr, Hillsborough, NC 27278, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1512-0d89-733a-a6c9-617e2d25a9e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-0d89-733a-a6c9-617e2d25a9e4",
        "storage_key": "property/5656427712479232/019f1512-0d89-733a-a6c9-617e2d25a9e4.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.asteptohealth.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9686861729826905440&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "a-step-to-health",
      "poi_latitude": "36.051722",
      "poi_longitude": "-79.095089",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 919-643-2273",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-d26f-73cf-8784-54a7a51dd1f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-d26f-73cf-8784-54a7a51dd1f6",
        "storage_key": "property/5656427712479232/019f150f-d26f-73cf-8784-54a7a51dd1f6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ5QOm_cjerIkRYJ2oimulboY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "ec_43cbe7940f0650029b6622f3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "Cates Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1445 Cates Creek Pkwy, Hillsborough, NC 27278, USA",
      "poi_short_description": "Park with a playground and picnic tables, plus a skate park.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1512-15b7-74ab-99c0-de65c8b6997d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-15b7-74ab-99c0-de65c8b6997d",
        "storage_key": "property/5656427712479232/019f1512-15b7-74ab-99c0-de65c8b6997d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=6441728178202803788&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cates-creek-park",
      "poi_latitude": "36.0484192",
      "poi_longitude": "-79.0952282",
      "poi_miles_from_property": "0.1 mi",
      "poi_walking_minutes": "2 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-d289-70d5-ac85-6a99a41099fe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-d289-70d5-ac85-6a99a41099fe",
        "storage_key": "property/5656427712479232/019f150f-d289-70d5-ac85-6a99a41099fe.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJqS2iCsPerIkRTP5m-aWdZVk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_a6959fe20142d6aa2a11c2fe",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "Occoneechee Mountain State Natural Area",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "625 Virginia Cates Rd, Hillsborough, NC 27278, USA",
      "poi_short_description": "This park has over 190 acres of land, mountain hiking trails & the highest land point in the county.",
      "poi_long_description": "This park has over 190 acres of land, mountain hiking trails & the highest land point in the county.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-b0e3-741c-9f2e-74599bd35d4e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-b0e3-741c-9f2e-74599bd35d4e",
        "storage_key": "property/5656427712479232/019f150f-b0e3-741c-9f2e-74599bd35d4e.webp",
        "width": 1280,
        "height": 1024
      },
      "poi_business_url": "https://www.ncparks.gov/state-parks/occoneechee-mountain-state-natural-area",
      "poi_directions_map_url": "https://maps.google.com/?cid=8809153252623159830&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "occoneechee-mountain-state-natural-area",
      "poi_latitude": "36.0606205",
      "poi_longitude": "-79.11710839999999",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 984-250-1370",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-d289-70d5-ac85-6a99a41099fe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-d289-70d5-ac85-6a99a41099fe",
        "storage_key": "property/5656427712479232/019f150f-d289-70d5-ac85-6a99a41099fe.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJr94oFS7ZrIkRFpKU2jVmQHo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "ec_c4749b1200344936fce9f92c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "Historic Occoneechee Speedway Trailhead",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "320 Elizabeth Brady Rd, Hillsborough, NC 27278, USA",
      "poi_short_description": "Historic dirt racetrack offering free admission and nature trails.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-8011-7369-9bd1-63a5815c663f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-8011-7369-9bd1-63a5815c663f",
        "storage_key": "property/5656427712479232/019f150f-8011-7369-9bd1-63a5815c663f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://visithillsboroughnc.com/things-to-do/historic-occoneechee-speedway-trail/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6610383361294818497&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "historic-occoneechee-speedway-trailhead",
      "poi_latitude": "36.0698752",
      "poi_longitude": "-79.08545149999999",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 919-732-6886",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-d276-7299-865c-5eb5f74e8236.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-d276-7299-865c-5eb5f74e8236",
        "storage_key": "property/5656427712479232/019f150f-d276-7299-865c-5eb5f74e8236.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjbVFCh_frIkRwVwhz6TMvFs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "ec_64ad540143ea7a707a25a893",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "Eno River Public Parking Deck",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Hillsborough, NC 27278, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=6878055500292711150&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eno-river-public-parking-deck",
      "poi_latitude": "36.0734619",
      "poi_longitude": "-79.1002292",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1512-4ef5-775c-8d71-cddefe3bf5c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-4ef5-775c-8d71-cddefe3bf5c7",
        "storage_key": "property/5656427712479232/019f1512-4ef5-775c-8d71-cddefe3bf5c7.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0a-gzijfrIkR7mJeOAnDc18",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "ec_e8c39ee690b560f413891347",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "Gold Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "415 Dimmocks Mill Rd, Hillsborough, NC 27278, USA",
      "poi_short_description": "Popular park, featuring a soccer field, playground, dog park and picnic shelters.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1511-fe5b-7548-9d9b-d5b726340c7e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-fe5b-7548-9d9b-d5b726340c7e",
        "storage_key": "property/5656427712479232/019f1511-fe5b-7548-9d9b-d5b726340c7e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://visithillsboroughnc.com/things-to-do/gold-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8084195782526240324&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gold-park",
      "poi_latitude": "36.0709326",
      "poi_longitude": "-79.1103703",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 919-732-1270",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-d289-70d5-ac85-6a99a41099fe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-d289-70d5-ac85-6a99a41099fe",
        "storage_key": "property/5656427712479232/019f150f-d289-70d5-ac85-6a99a41099fe.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9aYTWdXYrIkRRAYweDvVMHA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_d938b7d58602b6ad5a5f2393",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "Poets Walk at Ayr Mount",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Poet's Walk, Hillsborough, NC 27278, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1512-263d-7254-bf86-b7dd10030a58.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-263d-7254-bf86-b7dd10030a58",
        "storage_key": "property/5656427712479232/019f1512-263d-7254-bf86-b7dd10030a58.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://classicalamericanhomes.org/poets-walk/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5294892516246549634&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "poets-walk-at-ayr-mount",
      "poi_latitude": "36.0784455",
      "poi_longitude": "-79.0856785",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-d276-7299-865c-5eb5f74e8236.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-d276-7299-865c-5eb5f74e8236",
        "storage_key": "property/5656427712479232/019f150f-d276-7299-865c-5eb5f74e8236.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnxJOjrbfrIkRgvS_orA8e0k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "ec_51b8b622d6bc3f4a87bb08ee",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "Kings Highway Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1001 Ben Johnston Rd, Hillsborough, NC 27278, USA",
      "poi_short_description": "Peaceful park with a railroad bridge and hiking paths, plus trails for kayaking.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1512-2747-73f9-a7a9-c762cb6a1062.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-2747-73f9-a7a9-c762cb6a1062",
        "storage_key": "property/5656427712479232/019f1512-2747-73f9-a7a9-c762cb6a1062.webp",
        "width": 961,
        "height": 1280
      },
      "poi_business_url": "http://www.ci.hillsborough.nc.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18423804895550800578&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kings-highway-park",
      "poi_latitude": "36.072226",
      "poi_longitude": "-79.1320002",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 919-732-1270",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-d289-70d5-ac85-6a99a41099fe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-d289-70d5-ac85-6a99a41099fe",
        "storage_key": "property/5656427712479232/019f150f-d289-70d5-ac85-6a99a41099fe.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJu3d1ACDZrIkRwoJoYvCArv8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_323cacd8b6ad14ca814e39ef",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "Confluence Natural Area",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4214 Highland Farm Rd, Hillsborough, NC 27278, USA",
      "poi_short_description": "Easy hiking trails along the two forks of the Eno River are found in this wilderness park.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1512-21cd-7365-9f7b-4855c8565b61.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-21cd-7365-9f7b-4855c8565b61",
        "storage_key": "property/5656427712479232/019f1512-21cd-7365-9f7b-4855c8565b61.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.enoriver.org/features/confluence-natural-area/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9765120386177392331&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "confluence-natural-area",
      "poi_latitude": "36.1373722",
      "poi_longitude": "-79.1604049",
      "poi_miles_from_property": "8.6 mi",
      "poi_walking_minutes": "3 hours 10 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-d289-70d5-ac85-6a99a41099fe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-d289-70d5-ac85-6a99a41099fe",
        "storage_key": "property/5656427712479232/019f150f-d289-70d5-ac85-6a99a41099fe.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJX_wjmJ4nrYkRy14H30CthIc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "ec_5999bec0a2b0fc308205e811",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "Murray Street Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1101 Eno St, Hillsborough, NC 27278, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1512-3305-76ce-9a25-b13b1c481e03.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-3305-76ce-9a25-b13b1c481e03",
        "storage_key": "property/5656427712479232/019f1512-3305-76ce-9a25-b13b1c481e03.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://visithillsboroughnc.com/things-to-do/murray-street-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10063011389345106744&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "murray-street-park",
      "poi_latitude": "36.0698844",
      "poi_longitude": "-79.120177",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 919-245-2660",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-d289-70d5-ac85-6a99a41099fe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-d289-70d5-ac85-6a99a41099fe",
        "storage_key": "property/5656427712479232/019f150f-d289-70d5-ac85-6a99a41099fe.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJcVJmGyjZrIkROAug4Ir_pos",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_0094060cf9680d7dc2faf1f1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "Hillsborough Heights Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "506 Terrell Rd, Hillsborough, NC 27278, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1512-1ff0-75c6-9328-22d7983eb64d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-1ff0-75c6-9328-22d7983eb64d",
        "storage_key": "property/5656427712479232/019f1512-1ff0-75c6-9328-22d7983eb64d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.hillsboroughnc.gov/Home/Components/FacilityDirectory/FacilityDirectory/76/34",
      "poi_directions_map_url": "https://maps.google.com/?cid=15894969744896093440&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hillsborough-heights-park",
      "poi_latitude": "36.0845063",
      "poi_longitude": "-79.1149397",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 919-732-1270",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-d289-70d5-ac85-6a99a41099fe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-d289-70d5-ac85-6a99a41099fe",
        "storage_key": "property/5656427712479232/019f150f-d289-70d5-ac85-6a99a41099fe.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJYdQRIszYrIkRAO0ckMRGltw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_4eb9d016dba1785eee78da11",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "Durham Tech Community College Orange County Campus",
      "poi_type": "Transportation & Transit",
      "poi_address": "525 College Park Rd, Hillsborough, NC 27278, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-7511-733c-a210-91c63d305636.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-7511-733c-a210-91c63d305636",
        "storage_key": "property/5656427712479232/019f150f-7511-733c-a210-91c63d305636.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.durhamtech.edu/orange-county-campus",
      "poi_directions_map_url": "https://maps.google.com/?cid=16936686267357057451&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "durham-tech-community-college-orange-county-campus",
      "poi_latitude": "36.04103",
      "poi_longitude": "-79.09288699999999",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 919-536-7238",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-d26f-73cf-8784-54a7a51dd1f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-d26f-73cf-8784-54a7a51dd1f6",
        "storage_key": "property/5656427712479232/019f150f-d26f-73cf-8784-54a7a51dd1f6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJLSXBVLnerIkRq9EN_mwyC-s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_65614fdd65df84698ff14b99",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "Orange County Public Transportation",
      "poi_type": "Transportation & Transit",
      "poi_address": "600 NC-86, Hillsborough, NC 27278, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1512-26f2-7196-abc7-63a0f08fd10c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-26f2-7196-abc7-63a0f08fd10c",
        "storage_key": "property/5656427712479232/019f1512-26f2-7196-abc7-63a0f08fd10c.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "https://www.orangecountync.gov/transportation",
      "poi_directions_map_url": "https://maps.google.com/?cid=290320232850789280&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orange-county-public-transportation",
      "poi_latitude": "36.0944974",
      "poi_longitude": "-79.10612379999999",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 919-245-2008",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1512-4f26-701d-a653-e19558231768.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-4f26-701d-a653-e19558231768",
        "storage_key": "property/5656427712479232/019f1512-4f26-701d-a653-e19558231768.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvaigp0vfrIkRoBMurrZsBwQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "ec_50660f234ed3902b343bee03",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "Durham",
      "poi_type": "Transportation & Transit",
      "poi_address": "601 W Main St #103, Durham, NC 27701, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1512-2df6-7588-b5ee-92dc4dedb26d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-2df6-7588-b5ee-92dc4dedb26d",
        "storage_key": "property/5656427712479232/019f1512-2df6-7588-b5ee-92dc4dedb26d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=DNC",
      "poi_directions_map_url": "https://maps.google.com/?cid=15065799645015795224&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "durham",
      "poi_latitude": "35.997447",
      "poi_longitude": "-78.9065231",
      "poi_miles_from_property": "13.9 mi",
      "poi_walking_minutes": "5 hours 3 mins",
      "poi_biking_minutes": "1 hour 11 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1512-4f2d-7152-b6b4-431e087807a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-4f2d-7152-b6b4-431e087807a9",
        "storage_key": "property/5656427712479232/019f1512-4f2d-7152-b6b4-431e087807a9.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJi3hjXg3krIkRGGZfgvR4FNE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "ec_ba666d9b817c8e4f9463e88b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "Raleigh-Durham International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "2400 John Brantley Blvd, Morrisville, NC 27560, USA",
      "poi_short_description": "Hub with domestic, London & Caribbean flights, plus a public observation area for plane-watching.",
      "poi_long_description": "Hub with domestic, London & Caribbean flights, plus a public observation area for plane-watching.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1512-2103-7375-85ed-8432f0488cbf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-2103-7375-85ed-8432f0488cbf",
        "storage_key": "property/5656427712479232/019f1512-2103-7375-85ed-8432f0488cbf.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.rdu.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16394108500305999341&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "raleigh-durham-international-airport",
      "poi_latitude": "35.8797678",
      "poi_longitude": "-78.7855512",
      "poi_miles_from_property": "26.8 mi",
      "poi_walking_minutes": "9 hours 45 mins",
      "poi_biking_minutes": "2 hours 22 mins",
      "poi_driving_minutes": "30 mins",
      "poi_business_phone": "+1 919-840-2123",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1512-4f2f-74e7-8237-a1c8c8e29596.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-4f2f-74e7-8237-a1c8c8e29596",
        "storage_key": "property/5656427712479232/019f1512-4f2f-74e7-8237-a1c8c8e29596.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJz3mOAvrwrIkR7XXzQdKSg-M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_757350099e3e0bf5f9554696",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "Mebane Cone Health Park-and-Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Mebane, NC 27302, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3681080089858989446&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mebane-cone-health-park-and-ride",
      "poi_latitude": "36.0746117",
      "poi_longitude": "-79.26991269999999",
      "poi_miles_from_property": "12.0 mi",
      "poi_walking_minutes": "4 hours 23 mins",
      "poi_biking_minutes": "1 hour 6 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-d276-7299-865c-5eb5f74e8236.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-d276-7299-865c-5eb5f74e8236",
        "storage_key": "property/5656427712479232/019f150f-d276-7299-865c-5eb5f74e8236.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQxBzC43WrIkRht3OqdbSFTM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_c31036b02a2caa8a1720be9f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "TA Travel Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "1101 NC-61, Whitsett, NC 27377, USA",
      "poi_short_description": "Popular truck stop featuring clean restrooms and friendly staff, plus Burger King and Popeyes outlets.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1512-2e5d-760d-a88e-c42506c070da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-2e5d-760d-a88e-c42506c070da",
        "storage_key": "property/5656427712479232/019f1512-2e5d-760d-a88e-c42506c070da.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.ta-petro.com/location/nc/ta-greensboro",
      "poi_directions_map_url": "https://maps.google.com/?cid=10344356709441950987&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ta-travel-center",
      "poi_latitude": "36.0635122",
      "poi_longitude": "-79.56359909999999",
      "poi_miles_from_property": "31.2 mi",
      "poi_walking_minutes": "11 hours 26 mins",
      "poi_biking_minutes": "2 hours 58 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 336-449-6060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-d276-7299-865c-5eb5f74e8236.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-d276-7299-865c-5eb5f74e8236",
        "storage_key": "property/5656427712479232/019f150f-d276-7299-865c-5eb5f74e8236.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSe9iZ_4lU4gRC1U32J6Jjo8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "rest_stop"
    },
    {
      "id": "ec_d49651f280a828bb1d419cad",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "Orange County Courthouse",
      "poi_type": "Transportation & Transit",
      "poi_address": "106 E Margaret Ln, Hillsborough, NC 27278, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1512-3554-72ba-b7d6-9515af0f90af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-3554-72ba-b7d6-9515af0f90af",
        "storage_key": "property/5656427712479232/019f1512-3554-72ba-b7d6-9515af0f90af.webp",
        "width": 1280,
        "height": 958
      },
      "poi_business_url": "https://www.nccourts.gov/locations/orange-county/orange-county-courthouse",
      "poi_directions_map_url": "https://maps.google.com/?cid=16638205683114691653&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orange-county-courthouse",
      "poi_latitude": "36.074377",
      "poi_longitude": "-79.0990784",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 919-644-4500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1512-4f26-701d-a653-e19558231768.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-4f26-701d-a653-e19558231768",
        "storage_key": "property/5656427712479232/019f1512-4f26-701d-a653-e19558231768.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJe5s9-yXfrIkRRczvcerH5uY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "courthouse"
    },
    {
      "id": "ec_e3262cde21a2d284dcafd3fb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "Town of Hillsborough Town Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "101 E Orange St, Hillsborough, NC 27278, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1512-3a15-765a-bf71-8257ce022740.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-3a15-765a-bf71-8257ce022740",
        "storage_key": "property/5656427712479232/019f1512-3a15-765a-bf71-8257ce022740.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.hillsboroughnc.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12011238382650283729&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "town-of-hillsborough-town-hall",
      "poi_latitude": "36.0819139",
      "poi_longitude": "-79.0990734",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 919-732-1270",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1512-4f26-701d-a653-e19558231768.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-4f26-701d-a653-e19558231768",
        "storage_key": "property/5656427712479232/019f1512-4f26-701d-a653-e19558231768.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWdrfhTDfrIkR0VZotqt9sKY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "ec_347703e8d9ab8263e8a098d5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "Orange County Land Records",
      "poi_type": "Major Employers & Offices",
      "poi_address": "228 S Churton St Ste 200 (2nd floor, Hillsborough, NC 27278, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1512-34f7-721b-80e7-76850882b563.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-34f7-721b-80e7-76850882b563",
        "storage_key": "property/5656427712479232/019f1512-34f7-721b-80e7-76850882b563.webp",
        "width": 1280,
        "height": 813
      },
      "poi_business_url": "https://www.orangecountync.gov/845/GIS-Addressing-Land-Records",
      "poi_directions_map_url": "https://maps.google.com/?cid=7937478727865098708&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orange-county-land-records",
      "poi_latitude": "36.0735017",
      "poi_longitude": "-79.0997196",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 919-245-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1512-4f26-701d-a653-e19558231768.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-4f26-701d-a653-e19558231768",
        "storage_key": "property/5656427712479232/019f1512-4f26-701d-a653-e19558231768.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmzfEsyjfrIkR1GGeMtmWJ24",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "ec_12003cbef2feef4e474386ae",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "Whitted Human Services Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "300 W Tryon St, Hillsborough, NC 27278, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.orangecountync.gov/Facilities/Facility/Details/Whitted-Human-Services-Building-23",
      "poi_directions_map_url": "https://maps.google.com/?cid=16735937945426424835&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "whitted-human-services-center",
      "poi_latitude": "36.0773283",
      "poi_longitude": "-79.10559860000001",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 919-245-2400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-d276-7299-865c-5eb5f74e8236.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-d276-7299-865c-5eb5f74e8236",
        "storage_key": "property/5656427712479232/019f150f-d276-7299-865c-5eb5f74e8236.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8xo0tS3frIkRA3Qf_OP-Qeg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_ea252e52f42ff4ed81b1f588",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "Orange County Sheriff",
      "poi_type": "Major Employers & Offices",
      "poi_address": "106 E Margaret Ln, Hillsborough, NC 27278, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1512-39b1-73b8-9da9-add303a7a563.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-39b1-73b8-9da9-add303a7a563",
        "storage_key": "property/5656427712479232/019f1512-39b1-73b8-9da9-add303a7a563.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.ocsonc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3919269610285097506&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orange-county-sheriff",
      "poi_latitude": "36.0742061",
      "poi_longitude": "-79.0987048",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 919-245-2900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1512-4f26-701d-a653-e19558231768.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-4f26-701d-a653-e19558231768",
        "storage_key": "property/5656427712479232/019f1512-4f26-701d-a653-e19558231768.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJe5s9-yXfrIkRIuIGBPIKZDY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "ec_466b33fa222b72d973bf4cb6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "UNC Hospitals",
      "poi_type": "Major Employers & Offices",
      "poi_address": "101 Manning Dr, Chapel Hill, NC 27514, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1512-35da-736d-a42a-611448b2a05c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-35da-736d-a42a-611448b2a05c",
        "storage_key": "property/5656427712479232/019f1512-35da-736d-a42a-611448b2a05c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.unchealth.org/care-services/locations/unc-hospitals-chapel-hill",
      "poi_directions_map_url": "https://maps.google.com/?cid=14366424787232512829&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "unc-hospitals",
      "poi_latitude": "35.9049367",
      "poi_longitude": "-79.0506255",
      "poi_miles_from_property": "11.4 mi",
      "poi_walking_minutes": "4 hours 10 mins",
      "poi_biking_minutes": "1 hour 15 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 984-974-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-d292-751a-81cc-dea852d419e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-d292-751a-81cc-dea852d419e8",
        "storage_key": "property/5656427712479232/019f150f-d292-751a-81cc-dea852d419e8.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJVV-BTu7CrIkRPVtcNzrLX8c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_38e268ad40c1f9df7ce5cbbf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "UNC College of Arts & Sciences",
      "poi_type": "Major Employers & Offices",
      "poi_address": "South Building, 205 South Building, Chapel Hill, NC 27599, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1512-3f97-72db-8ae4-5a838162116e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-3f97-72db-8ae4-5a838162116e",
        "storage_key": "property/5656427712479232/019f1512-3f97-72db-8ae4-5a838162116e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://college.unc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14746008227559996822&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "unc-college-of-arts--sciences",
      "poi_latitude": "35.9117368",
      "poi_longitude": "-79.05098",
      "poi_miles_from_property": "10.7 mi",
      "poi_walking_minutes": "3 hours 55 mins",
      "poi_biking_minutes": "1 hour 11 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 919-962-1165",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-d26f-73cf-8784-54a7a51dd1f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-d26f-73cf-8784-54a7a51dd1f6",
        "storage_key": "property/5656427712479232/019f150f-d26f-73cf-8784-54a7a51dd1f6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJdaPvSOjCrIkRln2z8lpYpMw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_982bfd7235d388f9ea226353",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "Chapel Hill-Carrboro City Schools",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Lincoln Center, 750 S Merritt Mill Rd, Chapel Hill, NC 27516, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1512-3f1c-7604-ab9f-cda5c2fe9ca4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-3f1c-7604-ab9f-cda5c2fe9ca4",
        "storage_key": "property/5656427712479232/019f1512-3f1c-7604-ab9f-cda5c2fe9ca4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chccs.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3297070396626724164&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chapel-hill-carrboro-city-schools",
      "poi_latitude": "35.9031295",
      "poi_longitude": "-79.0684967",
      "poi_miles_from_property": "11.8 mi",
      "poi_walking_minutes": "4 hours 18 mins",
      "poi_biking_minutes": "1 hour 8 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 919-967-8211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-d26f-73cf-8784-54a7a51dd1f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-d26f-73cf-8784-54a7a51dd1f6",
        "storage_key": "property/5656427712479232/019f150f-d26f-73cf-8784-54a7a51dd1f6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJt8wfGwPDrIkRRGVkng6MwS0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_b71e746cc938f2bee0db5609",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "Southern Human Services Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2501 Homestead Rd, Chapel Hill, NC 27516, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1512-3f96-7086-9c81-6a570e00cef1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-3f96-7086-9c81-6a570e00cef1",
        "storage_key": "property/5656427712479232/019f1512-3f96-7086-9c81-6a570e00cef1.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "https://www.orangecountync.gov/Directory.aspx?did=35",
      "poi_directions_map_url": "https://maps.google.com/?cid=17320187552332024199&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "southern-human-services-center",
      "poi_latitude": "35.9487612",
      "poi_longitude": "-79.06477699999999",
      "poi_miles_from_property": "8.4 mi",
      "poi_walking_minutes": "3 hours 4 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 919-913-8088",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1512-4f26-701d-a653-e19558231768.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-4f26-701d-a653-e19558231768",
        "storage_key": "property/5656427712479232/019f1512-4f26-701d-a653-e19558231768.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJF9FBiCfdrIkRh4nkA9CqXfA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "ec_585695f7b509c5445393df96",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "RTI International",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3040 E Cornwallis Rd, Research Triangle Park, NC 27709, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1512-404e-73ce-92b4-3646183a5f71.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-404e-73ce-92b4-3646183a5f71",
        "storage_key": "property/5656427712479232/019f1512-404e-73ce-92b4-3646183a5f71.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.rti.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17384809203008202574&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rti-international",
      "poi_latitude": "35.905487",
      "poi_longitude": "-78.86508169999999",
      "poi_miles_from_property": "19.4 mi",
      "poi_walking_minutes": "7 hours 3 mins",
      "poi_biking_minutes": "1 hour 55 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 919-541-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-d26f-73cf-8784-54a7a51dd1f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-d26f-73cf-8784-54a7a51dd1f6",
        "storage_key": "property/5656427712479232/019f150f-d26f-73cf-8784-54a7a51dd1f6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_cun0JPvrIkRTuc-idw_Q_E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "research_institute"
    },
    {
      "id": "ec_47e6905852b2beca39ab5aea",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "generator",
      "poi_name": "Duke University Chapel",
      "poi_type": "Major Employers & Offices",
      "poi_address": "401 Chapel Dr, Durham, NC 27708, USA",
      "poi_short_description": "Interdenominational campus church featuring a sizable tower, neo-gothic design & 3 pipe organs.",
      "poi_long_description": "Interdenominational campus church featuring a sizable tower, neo-gothic design & 3 pipe organs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1512-43dc-76e7-bd9e-25f8dfb5bc6e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-43dc-76e7-bd9e-25f8dfb5bc6e",
        "storage_key": "property/5656427712479232/019f1512-43dc-76e7-bd9e-25f8dfb5bc6e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.chapel.duke.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9959895850506257798&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "duke-university-chapel",
      "poi_latitude": "36.0019264",
      "poi_longitude": "-78.94033809999999",
      "poi_miles_from_property": "12.6 mi",
      "poi_walking_minutes": "4 hours 33 mins",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 919-681-9488",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1512-4f2f-74e7-8237-9e040bf5cc7a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-4f2f-74e7-8237-9e040bf5cc7a",
        "storage_key": "property/5656427712479232/019f1512-4f2f-74e7-8237-9e040bf5cc7a.webp",
        "width": 144,
        "height": 192
      },
      "poi_google_place_id": "ChIJx71m2a_mrIkRhgVQmYGoOIo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "church"
    }
  ],
  "office_hours": [
    {
      "id": "custom_cb795b8d-3ab4-49b1-9714-cbeab2e84bfe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_6a32733c-980e-496f-b60f-47900bbe23dc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_f93347af-43c9-4db9-a073-e3e90e22a836",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_94b3f2a4-bfa0-4d46-8074-dcd81b3eea8e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_b43fcdcd-63f1-4504-a8d2-051c95d3dadf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_1f37d434-d74a-458c-a11c-76cbaff1ef30",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_37661973927d5b67df6d2984",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "rating": "5",
      "name": "Cindy W",
      "text": "At  Cadence Creek apartments the maintenance staff is always prompt and friendly. Problems are resolved either on the day or within one to two days. The leasing office staff tries very hard to listen to requests and help residents  feel comfortable and happy. The apartments have beautiful amenities. Stainless steel and hardwood floors are beautiful.",
      "date": "2026-01-28",
      "title": "false"
    },
    {
      "id": "ec_24d6d09fd754e2297981aa5a",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "rating": "5",
      "name": "Jane Lowe-Rodriguez",
      "text": "We have rented at Cadence at Cates Creek for close to 2 years. We love the apartment. A roomy one bedroom, with lots of storage space, especially in the oversized walk-in bedroom closet. The amenities, like the pool and gym, are excellent and well maintained, as is the entire property. The staff are very friendly and helpful. Maintenance issue are generally handled the same day. Highly recommend!",
      "date": "2026-01-13",
      "title": "false"
    },
    {
      "id": "ec_a213baaf962dd2eb0f91c500",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "rating": "5",
      "name": "Jenn Barnes",
      "text": "I have lived here for 5-6 years and plan to stay as long as the rent remains in my price range. The maintenance and front desk staff are great, complex is very quiet and neighbors are friendly. They have started sponsoring community events such as weekly food trucks. I have virtually no complaints. Happy to be a resident!",
      "date": "2026-02-05",
      "title": "false"
    },
    {
      "id": "ec_6020a2335d23a76c0baf26e0",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "rating": "5",
      "name": "deborah mcpeek",
      "text": "Ardmore Cates Creek deserves kudos for being the perfect apartment home. The staff - Ashley, Robyn, Eddie and Jay - are always courteous and polite to everyone. The tenets are their first priority and they do everything they can to make us feel welcome and respected. After living in our home for 35 years, moving to an apartment was a big adjustment. But after 6 months, it was the smartest move we could have made. My husband and I visited around 9 apartment complexes in Durham and Cates Creek was by far the superior choice. If you are looking for a \"home\", this is the place to be. Area is becoming more beautiful every day as the complex is being completed. And, management is top notch in my opinion. Attached is a picture of the outside of our apartment. Home Sweet Home.",
      "date": "2016-12-29",
      "title": "false"
    },
    {
      "id": "ec_a7d28ace04fb7a424f8e2971",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "rating": "5",
      "name": "Vera McRae",
      "text": "Tyrone Sandusky was very professional, cordial, and done an exceptional job completing my maintenance request in a timely manner.  Job well done.",
      "date": "2026-01-12",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_bcbee14d-34a4-4da2-ba5b-bb4203044870",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Cadence at Cates Creek",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://vapi.apartments.com/video/play/5t3a3f?source=180"
    },
    {
      "id": "custom_cb374a90-0070-4360-ab64-b34c310de6e3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019d02ef-e676-7569-8964-07997bcd5f2b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Stylish living room with a sectional sofa, coffee table, and modern decor.",
        "public_id": "019d02ef-e676-7569-8964-07997bcd5f2b",
        "storage_key": "property/5656427712479232/019d02ef-e676-7569-8964-07997bcd5f2b.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 2BA - 1,103SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=eWaQWjMgjag"
    },
    {
      "id": "custom_a7ae4247-2cad-4afc-ba11-eeb2ca03433b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019d02ef-e6c4-701c-8166-a3ebd209084a.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern communal lounge area with comfortable seating and abstract art.",
        "public_id": "019d02ef-e6c4-701c-8166-a3ebd209084a",
        "storage_key": "property/5656427712479232/019d02ef-e6c4-701c-8166-a3ebd209084a.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Clubhouse",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=Va36Ys5JZFa"
    },
    {
      "id": "custom_627df6b1-49ed-4a53-ab40-f33f464b857f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019d02ef-e6c3-7466-a423-85974ba06044.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern fitness center with treadmills, weight machines, and an elliptical.",
        "public_id": "019d02ef-e6c3-7466-a423-85974ba06044",
        "storage_key": "property/5656427712479232/019d02ef-e6c3-7466-a423-85974ba06044.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=TALJ6xGYqJQ"
    },
    {
      "id": "custom_d4f827ab-64b0-4946-b4a8-554583392271",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019d02ef-5998-7266-a963-814359c3965e.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Interior view of an apartment kitchen and hallway with washer and dryer closet.",
        "public_id": "019d02ef-5998-7266-a963-814359c3965e",
        "storage_key": "property/5656427712479232/019d02ef-5998-7266-a963-814359c3965e.webp",
        "width": 2048,
        "height": 1152
      },
      "virtual_tour_title": "3BR, 2BA - 1,509SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=eKUnLzEX8Qc"
    }
  ],
  "faqs": [
    {
      "id": "custom_e1e187d1-e7f7-4fe9-a3a3-7c607ef4571b",
      "question": "Is Cadence at Cates Creek pet-friendly?",
      "answer": "Yes. Cadence at Cates Creek welcomes cats and dogs, up to 2 pets per home, with no posted weight limit. Some breed restrictions apply. Assistance animals (service animals and emotional support animals) are not pets under fair housing law, so they are not subject to pet fees, deposits, or breed and weight restrictions. For the full pet policy, call the leasing team at (919) 245-8947 or visit our contact page.",
      "category": "Pet Policy",
      "source": "custom"
    },
    {
      "id": "custom_9e3a11cd-8a76-476c-9794-e29bb21cc06c",
      "question": "How can I schedule a tour at Cadence at Cates Creek?",
      "answer": "You can schedule a tour of Cadence at Cates Creek online through our Schedule a Tour page, or call the leasing office at (919) 245-8947. You can also view our virtual tours to see the community before visiting in person.",
      "category": "Contact & Tours",
      "source": "custom"
    },
    {
      "id": "custom_f7948f3b-bd2f-4da3-b0ad-10459a221420",
      "question": "What are the leasing office hours at Cadence at Cates Creek?",
      "answer": "The Cadence at Cates Creek leasing office is open during these hours:\n\n• Monday: 9:00 AM to 6:00 PM\n• Tuesday: 9:00 AM to 6:00 PM\n• Wednesday: 9:00 AM to 6:00 PM\n• Thursday: 9:00 AM to 6:00 PM\n• Friday: 9:00 AM to 6:00 PM\n• Saturday: 10:00 AM to 5:00 PM\n\nHours may change around holidays. Call (919) 245-8947 or visit our contact page to confirm before you visit.",
      "category": "Office Hours",
      "source": "custom"
    },
    {
      "id": "custom_2b3e9ec9-7009-4d51-ac73-dfcd8a255185",
      "question": "What floor plans are available at Cadence at Cates Creek?",
      "answer": "Cadence at Cates Creek offers 1- to 3-bedroom apartment homes ranging from approximately 753 to 1,509 square feet, across 3 floor plans. View layouts, square footage, and current availability on our Floor Plans page, or schedule a tour to see them in person.",
      "category": "Floor Plans & Units",
      "source": "custom"
    },
    {
      "id": "custom_bf846ebe-c98c-485d-b7a8-0b2e870db40a",
      "question": "What amenities does Cadence at Cates Creek have?",
      "answer": "Cadence at Cates Creek offers a range of community and in-home amenities. Community amenities include: Pool, 24 Hour Fitness Center, Modern Clubhouse With Resident Lounge, High‑Tech Business Center, Personal Garages Available, Outdoor Fireplace With Relaxing Lounge, Poolside Grilling Pavilion, Complimentary Starbucks Coffee Bar, Pet Park With Pet Wash Station, Car Care Station, Credit Building Services Powered by RentPlus, Convenient 24/7 Online Resident Services, and American Landmark 360 Resident Program. In-home features include: 1, 2 & 3 bedroom floor plans, stainless‑steel‑style appliances, modern kitchens, granite countertops, designer cabinetry, built‑in microwaves, brushed nickel finishes, wood‑style flooring, 9‑foot ceilings with crown molding, walk‑in closets, washer & dryer connections, private patio or juliette balcony, open concept floor plans, pool views*, and pet‑friendly homes. See the complete list on our Amenities page.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_3dbe2646-b399-42d9-8bb6-1b4f6966b9aa",
      "question": "Where is Cadence at Cates Creek located?",
      "answer": "Cadence at Cates Creek is located at 100 Waterstone Park Cir, Hillsborough NC 27278. Nearby you'll find dining at Antonia's Restaurant, shopping at Weaver Street Market, and green space at Cates Creek Park. Explore more on our Neighborhood page.",
      "category": "Location & Neighborhood",
      "source": "custom"
    },
    {
      "id": "custom_03d05747-d599-4c99-9b6c-9ca771e5c3c0",
      "question": "How do I apply to live at Cadence at Cates Creek?",
      "answer": "You can apply to live at Cadence at Cates Creek online through our Apply Now page, which walks you through each step. If you have questions, the leasing team can help. Call (919) 245-8947 or reach out through our contact page.",
      "category": "Application Process",
      "source": "custom"
    },
    {
      "id": "custom_9f88f12f-6da4-48fb-a449-335dcd35e8f0",
      "question": "What do I need to apply at Cadence at Cates Creek?",
      "answer": "Applicants should be ready to provide standard rental application information, including government-issued identification, proof of income, and rental history. Qualification requirements can vary, so we recommend confirming the current criteria with the Cadence at Cates Creek leasing team at (919) 245-8947 or on our contact page. When you're ready, start on the Apply Now page.",
      "category": "Application Process",
      "source": "custom"
    },
    {
      "id": "custom_afcf9fd5-a707-461b-8eee-f858b510828a",
      "question": "What is the Landmark 360 program at Cadence at Cates Creek?",
      "answer": "Cadence at Cates Creek participates in American Landmark's Landmark 360 resident program, which includes three resident promises:\n\n• Move-In Satisfaction Promise: if you are not satisfied within your first 15 days, American Landmark will refund your deposit and waive lease-termination fees.\n• 48-Hour Maintenance Completion Promise: work orders are completed within 48 hours (Monday through Friday), with rent credits if that timeline is missed.\n• Relocation Promise: after six months on your lease, you can transfer to another American Landmark community without penalties, with 60 days' written notice.\nTo learn more, contact the leasing team at (919) 245-8947 or visit our contact page.",
      "category": "Resident Programs",
      "source": "custom"
    },
    {
      "id": "custom_71e0874e-1c04-47d8-a64c-fd627f9afdbb",
      "question": "Does Cadence at Cates Creek have a pool?",
      "answer": "Yes. Cadence at Cates Creek has a swimming pool for residents. See it alongside our other community amenities on the Amenities page.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_5fc913c9-57e4-4e65-ad4d-88b0e6b121ca",
      "question": "Does Cadence at Cates Creek have a fitness center?",
      "answer": "Yes. Cadence at Cates Creek has a 24-hour fitness center available to residents at any time. See all amenities on the Amenities page, or schedule a tour to view it in person.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_4e12b89b-1036-4be2-9356-d58c60553cd3",
      "question": "Does Cadence at Cates Creek offer virtual tours?",
      "answer": "Yes. Cadence at Cates Creek offers virtual tours of Cadence at Cates Creek, 2BR, 2BA - 1,103SF, Clubhouse, Fitness Center, and 3BR, 2BA - 1,509SF. Start on our Virtual Tours page, then schedule an in-person tour when you are ready.",
      "category": "Contact & Tours",
      "source": "custom"
    },
    {
      "id": "custom_3783d64f-a1ac-42a7-be80-3b0c18ce0f19",
      "question": "What do residents say about living at Cadence at Cates Creek?",
      "answer": "Residents frequently mention the helpful staff and responsive maintenance at Cadence at Cates Creek. One resident wrote: *\"At Cadence Creek apartments the maintenance staff is always prompt and friendly. Problems are resolved either on the day or within one to two days.\"* Read more resident reviews on our Reviews page.",
      "category": "Resident Life",
      "source": "custom"
    },
    {
      "id": "custom_f170fb08-93ff-4a11-9886-4dd6ea81c88f",
      "question": "When was Cadence at Cates Creek built?",
      "answer": "Cadence at Cates Creek was built in 2016 and renovated in 2022. Schedule a tour to see the finishes in person.",
      "category": "Property History & Features",
      "source": "custom"
    },
    {
      "id": "custom_3a68d2f8-03b1-4a0f-ba46-bb4a1ae15f6f",
      "question": "What is the pet fee at Cadence at Cates Creek?",
      "answer": "Pets at Cadence at Cates Creek: cats and dogs are welcome, up to 2 per home, with no posted weight limit. Some breed restrictions apply. Assistance animals (service animals and emotional support animals) are not pets under fair housing law, so they are not subject to pet fees, deposits, or breed and weight restrictions. For details, contact the leasing team at (919) 245-8947 or visit our contact page.",
      "category": "Pet Policy",
      "source": "custom"
    },
    {
      "id": "custom_a6bedd9f-08fc-4bed-b69c-f129aae22c1a",
      "question": "What features are included in the apartments at Cadence at Cates Creek?",
      "answer": "Apartment homes at Cadence at Cates Creek include 1, 2 & 3 bedroom floor plans, stainless‑steel‑style appliances, modern kitchens, granite countertops, designer cabinetry, built‑in microwaves, brushed nickel finishes, wood‑style flooring, 9‑foot ceilings with crown molding, walk‑in closets, washer & dryer connections, private patio or juliette balcony, open concept floor plans, pool views*, and pet‑friendly homes. Browse layouts on our Floor Plans page or schedule a tour.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_809918ea-7ddf-4b80-9b07-c3be88145e45",
      "question": "What restaurants and shops are near Cadence at Cates Creek?",
      "answer": "Nearby restaurants and shops include Antonia's Restaurant, Serratore's Pasta and Pizza, Hillsborough Bakeshop & Cafe, and Saratoga Grill. See the full neighborhood guide on our Neighborhood page.",
      "category": "Location & Neighborhood",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa45-41de-73fa-874f-90fa05184ebc",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "cadence-at-cates-creek",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232"
    },
    {
      "lead_collector_id": "0198aa45-4241-7026-8409-dc4a1522cf0f",
      "lead_source": "FACEBOOK_ADS",
      "name": "cadence-at-cates-creek",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232"
    },
    {
      "lead_collector_id": "0198aa45-42a4-70ec-b073-b1185cfccdf2",
      "lead_source": "LANDING_PAGE",
      "name": "cadence-at-cates-creek",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-for-rent-hillsborough-nc",
      "search_query": "One Bedroom Apartments For Rent In Hillsborough NC",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments For Rent In Hillsborough NC",
      "h2_subtitle": "Discover luxury living at Cadence at Cates Creek. Our one bedroom apartments offer modern amenities and a prime location in Hillsborough, NC.",
      "page_copy": "Settle into a life of comfort, convenience, and luxury at Cadence at Cates Creek. Our one bedroom apartments for rent in Hillsborough, NC, feature upscale interiors with wood-style flooring, crown molding, and private patios or Juliette balconies. Enjoy modern kitchens with stainless-steel-style appliances, granite countertops, and designer cabinetry. Located near UNC Medical Center, our community offers easy access to downtown shops, restaurants, and the Hillsborough Riverwalk. With amenities like a pool, pet-friendly homes, and open concept floor plans, Cadence at Cates Creek is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f6c0c-cdc5-748e-bcc4-8b95b0a87465.webp",
      "featured_image_media": {
        "alt_text": "Luxury swimming pool and lounge area with lounge chairs and umbrellas.",
        "public_id": "019f6c0c-cdc5-748e-bcc4-8b95b0a87465",
        "storage_key": "property/5656427712479232/019f6c0c-cdc5-748e-bcc4-8b95b0a87465.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f6c0c-d8cc-72e9-adc3-16515fbf8c01.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a modern apartment building with a clear sky.",
        "public_id": "019f6c0c-d8cc-72e9-adc3-16515fbf8c01",
        "storage_key": "property/5656427712479232/019f6c0c-d8cc-72e9-adc3-16515fbf8c01.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Cadence at Cates Creek | One Bedroom Apartments For Rent In Hillsborough NC",
      "seo_description": "Discover luxury one bedroom apartments for rent in Hillsborough, NC at Cadence at Cates Creek. Enjoy modern amenities and a prime location near UNC Medical Center.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "custom",
      "page_item_url": "two-bedrooms-apartments-for-rent-hillsborough-nc",
      "search_query": "Two Bedrooms Apartments For Rent In Hillsborough NC",
      "category": "Floorplan",
      "h1_title": "Two Bedrooms Apartments For Rent In Hillsborough NC",
      "h2_subtitle": "Experience luxury living at Cadence at Cates Creek. Our two bedroom apartments offer modern amenities and a prime location in Hillsborough, NC.",
      "page_copy": "Settle into a life of comfort, convenience, and luxury at Cadence at Cates Creek. Our two bedrooms apartments for rent in Hillsborough, NC, feature upscale interiors with wood-style flooring, crown molding, and private patios or Juliette balconies. Enjoy modern kitchens with stainless-steel-style appliances, granite countertops, and designer cabinetry. Located near UNC Medical Center, our community offers easy access to downtown shops, restaurants, and the Hillsborough Riverwalk. With amenities like a pool, pet-friendly homes, and open concept floor plans, Cadence at Cates Creek is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f6c0c-cdc5-748e-bcc4-8b95b0a87465.webp",
      "featured_image_media": {
        "alt_text": "Luxury swimming pool and lounge area with lounge chairs and umbrellas.",
        "public_id": "019f6c0c-cdc5-748e-bcc4-8b95b0a87465",
        "storage_key": "property/5656427712479232/019f6c0c-cdc5-748e-bcc4-8b95b0a87465.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f6c0c-d8cc-72e9-adc3-16515fbf8c01.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a modern apartment building with a clear sky.",
        "public_id": "019f6c0c-d8cc-72e9-adc3-16515fbf8c01",
        "storage_key": "property/5656427712479232/019f6c0c-d8cc-72e9-adc3-16515fbf8c01.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Cadence at Cates Creek | Two Bedrooms Apartments For Rent In Hillsborough NC",
      "seo_description": "Discover luxury two bedrooms apartments for rent in Hillsborough, NC at Cadence at Cates Creek. Enjoy modern amenities and a prime location near UNC Medical Center.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "custom",
      "page_item_url": "three-bedrooms-apartments-for-rent-hillsborough-nc",
      "search_query": "Three Bedrooms Apartments For Rent In Hillsborough NC",
      "category": "Floorplan",
      "h1_title": "Three Bedrooms Apartments For Rent In Hillsborough NC",
      "h2_subtitle": "Indulge in luxury living at Cadence at Cates Creek. Our three bedroom apartments offer modern amenities and a prime location in Hillsborough, NC.",
      "page_copy": "Settle into a life of comfort, convenience, and luxury at Cadence at Cates Creek. Our three bedrooms apartments for rent in Hillsborough, NC, feature upscale interiors with wood-style flooring, crown molding, and private patios or Juliette balconies. Enjoy modern kitchens with stainless-steel-style appliances, granite countertops, and designer cabinetry. Located near UNC Medical Center, our community offers easy access to downtown shops, restaurants, and the Hillsborough Riverwalk. With amenities like a pool, pet-friendly homes, and open concept floor plans, Cadence at Cates Creek is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f6c0c-cdc5-748e-bcc4-8b95b0a87465.webp",
      "featured_image_media": {
        "alt_text": "Luxury swimming pool and lounge area with lounge chairs and umbrellas.",
        "public_id": "019f6c0c-cdc5-748e-bcc4-8b95b0a87465",
        "storage_key": "property/5656427712479232/019f6c0c-cdc5-748e-bcc4-8b95b0a87465.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f6c0c-d8cc-72e9-adc3-16515fbf8c01.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a modern apartment building with a clear sky.",
        "public_id": "019f6c0c-d8cc-72e9-adc3-16515fbf8c01",
        "storage_key": "property/5656427712479232/019f6c0c-d8cc-72e9-adc3-16515fbf8c01.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Cadence at Cates Creek | Three Bedrooms Apartments For Rent In Hillsborough NC",
      "seo_description": "Discover luxury three bedrooms apartments for rent in Hillsborough, NC at Cadence at Cates Creek. Enjoy modern amenities and a prime location near UNC Medical Center.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-resort-style-pool",
      "search_query": "Apartments For Rent Near Me with Resort Style Saltwater Pool",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Resort Style Saltwater Pool",
      "h2_subtitle": "Experience luxury living at Cadence at Cates Creek. Our apartments offer modern amenities and a resort style saltwater pool in Hillsborough, NC.",
      "page_copy": "Settle into a life of comfort, convenience, and luxury at Cadence at Cates Creek. Our apartments for rent near me with resort style saltwater pool feature upscale interiors with wood-style flooring, crown molding, and private patios or Juliette balconies. Enjoy modern kitchens with stainless-steel-style appliances, granite countertops, and designer cabinetry. Located near UNC Medical Center, our community offers easy access to downtown shops, restaurants, and the Hillsborough Riverwalk. With amenities like a resort style saltwater pool, 24-hour fitness center, and pet-friendly homes, Cadence at Cates Creek is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f6c0c-cdc5-748e-bcc4-8b95b0a87465.webp",
      "featured_image_media": {
        "alt_text": "Luxury swimming pool and lounge area with lounge chairs and umbrellas.",
        "public_id": "019f6c0c-cdc5-748e-bcc4-8b95b0a87465",
        "storage_key": "property/5656427712479232/019f6c0c-cdc5-748e-bcc4-8b95b0a87465.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f6c0c-d8cc-72e9-adc3-16515fbf8c01.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a modern apartment building with a clear sky.",
        "public_id": "019f6c0c-d8cc-72e9-adc3-16515fbf8c01",
        "storage_key": "property/5656427712479232/019f6c0c-d8cc-72e9-adc3-16515fbf8c01.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Cadence at Cates Creek | Apartments For Rent Near Me with Resort Style Saltwater Pool",
      "seo_description": "Discover luxury apartments for rent near me with resort style saltwater pool at Cadence at Cates Creek in Hillsborough, NC. Enjoy modern amenities and prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-24-hour-fitness-center",
      "search_query": "Apartments For Rent Near Me with 24 Hour Fitness Center",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with 24 Hour Fitness Center",
      "h2_subtitle": "Discover luxury living at Cadence at Cates Creek. Our apartments offer modern amenities and a 24 hour fitness center in Hillsborough, NC.",
      "page_copy": "Settle into a life of comfort, convenience, and luxury at Cadence at Cates Creek. Our apartments for rent near me with 24 hour fitness center feature upscale interiors with wood-style flooring, crown molding, and private patios or Juliette balconies. Enjoy modern kitchens with stainless-steel-style appliances, granite countertops, and designer cabinetry. Located near UNC Medical Center, our community offers easy access to downtown shops, restaurants, and the Hillsborough Riverwalk. With amenities like a 24 hour fitness center, resort style saltwater pool, and pet-friendly homes, Cadence at Cates Creek is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f6c0c-cdc5-748e-bcc4-8b95b0a87465.webp",
      "featured_image_media": {
        "alt_text": "Luxury swimming pool and lounge area with lounge chairs and umbrellas.",
        "public_id": "019f6c0c-cdc5-748e-bcc4-8b95b0a87465",
        "storage_key": "property/5656427712479232/019f6c0c-cdc5-748e-bcc4-8b95b0a87465.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f6c0c-d8cc-72e9-adc3-16515fbf8c01.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a modern apartment building with a clear sky.",
        "public_id": "019f6c0c-d8cc-72e9-adc3-16515fbf8c01",
        "storage_key": "property/5656427712479232/019f6c0c-d8cc-72e9-adc3-16515fbf8c01.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Cadence at Cates Creek | Apartments For Rent Near Me with 24 Hour Fitness Center",
      "seo_description": "Discover luxury apartments for rent near me with 24 hour fitness center at Cadence at Cates Creek in Hillsborough, NC. Enjoy modern amenities and prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-modern-clubhouse-lounge",
      "search_query": "Apartments For Rent Near Me with Modern Clubhouse With Resident Lounge",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Modern Clubhouse With Resident Lounge",
      "h2_subtitle": "Experience luxury living at Cadence at Cates Creek. Our apartments offer modern amenities and a modern clubhouse with resident lounge in Hillsborough, NC.",
      "page_copy": "Settle into a life of comfort, convenience, and luxury at Cadence at Cates Creek. Our apartments for rent near me with modern clubhouse with resident lounge feature upscale interiors with wood-style flooring, crown molding, and private patios or Juliette balconies. Enjoy modern kitchens with stainless-steel-style appliances, granite countertops, and designer cabinetry. Located near UNC Medical Center, our community offers easy access to downtown shops, restaurants, and the Hillsborough Riverwalk. With amenities like a modern clubhouse with resident lounge, resort style saltwater pool, and pet-friendly homes, Cadence at Cates Creek is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f6c0c-cdc5-748e-bcc4-8b95b0a87465.webp",
      "featured_image_media": {
        "alt_text": "Luxury swimming pool and lounge area with lounge chairs and umbrellas.",
        "public_id": "019f6c0c-cdc5-748e-bcc4-8b95b0a87465",
        "storage_key": "property/5656427712479232/019f6c0c-cdc5-748e-bcc4-8b95b0a87465.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f6c0c-d8cc-72e9-adc3-16515fbf8c01.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a modern apartment building with a clear sky.",
        "public_id": "019f6c0c-d8cc-72e9-adc3-16515fbf8c01",
        "storage_key": "property/5656427712479232/019f6c0c-d8cc-72e9-adc3-16515fbf8c01.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Cadence at Cates Creek | Apartments For Rent Near Me with Modern Clubhouse With Resident Lounge",
      "seo_description": "Discover luxury apartments for rent near me with modern clubhouse with resident lounge at Cadence at Cates Creek in Hillsborough, NC. Enjoy modern amenities and prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-pet-park-wash-station",
      "search_query": "Apartments For Rent Near Me with Pet Park With Pet Wash Station",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Pet Park With Pet Wash Station",
      "h2_subtitle": "Discover luxury living at Cadence at Cates Creek. Our apartments offer modern amenities and a pet park with pet wash station in Hillsborough, NC.",
      "page_copy": "Settle into a life of comfort, convenience, and luxury at Cadence at Cates Creek. Our apartments for rent near me with pet park with pet wash station feature upscale interiors with wood-style flooring, crown molding, and private patios or Juliette balconies. Enjoy modern kitchens with stainless-steel-style appliances, granite countertops, and designer cabinetry. Located near UNC Medical Center, our community offers easy access to downtown shops, restaurants, and the Hillsborough Riverwalk. With amenities like a pet park with pet wash station, resort style saltwater pool, and pet-friendly homes, Cadence at Cates Creek is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f6c0c-cdc5-748e-bcc4-8b95b0a87465.webp",
      "featured_image_media": {
        "alt_text": "Luxury swimming pool and lounge area with lounge chairs and umbrellas.",
        "public_id": "019f6c0c-cdc5-748e-bcc4-8b95b0a87465",
        "storage_key": "property/5656427712479232/019f6c0c-cdc5-748e-bcc4-8b95b0a87465.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f6c0c-d8cc-72e9-adc3-16515fbf8c01.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a modern apartment building with a clear sky.",
        "public_id": "019f6c0c-d8cc-72e9-adc3-16515fbf8c01",
        "storage_key": "property/5656427712479232/019f6c0c-d8cc-72e9-adc3-16515fbf8c01.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Cadence at Cates Creek | Apartments For Rent Near Me with Pet Park With Pet Wash Station",
      "seo_description": "Discover luxury apartments for rent near me with pet park with pet wash station at Cadence at Cates Creek in Hillsborough, NC. Enjoy modern amenities and prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-online-resident-services",
      "search_query": "Apartments For Rent Near Me with Convenient 24/7 Online Resident Services",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Convenient 24/7 Online Resident Services",
      "h2_subtitle": "Experience luxury living at Cadence at Cates Creek. Our apartments offer modern amenities and convenient 24/7 online resident services in Hillsborough, NC.",
      "page_copy": "Settle into a life of comfort, convenience, and luxury at Cadence at Cates Creek. Our apartments for rent near me with convenient 24/7 online resident services feature upscale interiors with wood-style flooring, crown molding, and private patios or Juliette balconies. Enjoy modern kitchens with stainless-steel-style appliances, granite countertops, and designer cabinetry. Located near UNC Medical Center, our community offers easy access to downtown shops, restaurants, and the Hillsborough Riverwalk. With amenities like convenient 24/7 online resident services, a resort style saltwater pool, and pet-friendly homes, Cadence at Cates Creek is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f6c0c-cdc5-748e-bcc4-8b95b0a87465.webp",
      "featured_image_media": {
        "alt_text": "Luxury swimming pool and lounge area with lounge chairs and umbrellas.",
        "public_id": "019f6c0c-cdc5-748e-bcc4-8b95b0a87465",
        "storage_key": "property/5656427712479232/019f6c0c-cdc5-748e-bcc4-8b95b0a87465.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f6c0c-d8cc-72e9-adc3-16515fbf8c01.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a modern apartment building with a clear sky.",
        "public_id": "019f6c0c-d8cc-72e9-adc3-16515fbf8c01",
        "storage_key": "property/5656427712479232/019f6c0c-d8cc-72e9-adc3-16515fbf8c01.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Cadence at Cates Creek | Apartments For Rent Near Me with Convenient 24/7 Online Resident Services",
      "seo_description": "Discover luxury apartments for rent near me with convenient 24/7 online resident services at Cadence at Cates Creek in Hillsborough, NC. Enjoy modern amenities and prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-bedroom-floor-plans",
      "search_query": "Apartments For Rent Near Me with 1, 2 & 3 Bedroom Floor Plans",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with 1, 2 & 3 Bedroom Floor Plans",
      "h2_subtitle": "Discover luxury living at Cadence at Cates Creek. Our apartments offer modern amenities and 1, 2 & 3 bedroom floor plans in Hillsborough, NC.",
      "page_copy": "Settle into a life of comfort, convenience, and luxury at Cadence at Cates Creek. Our apartments for rent near me with 1, 2 & 3 bedroom floor plans feature upscale interiors with wood-style flooring, crown molding, and private patios or Juliette balconies. Enjoy modern kitchens with stainless-steel-style appliances, granite countertops, and designer cabinetry. Located near UNC Medical Center, our community offers easy access to downtown shops, restaurants, and the Hillsborough Riverwalk. With amenities like 1, 2 & 3 bedroom floor plans, a resort style saltwater pool, and pet-friendly homes, Cadence at Cates Creek is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f6c0c-cdc5-748e-bcc4-8b95b0a87465.webp",
      "featured_image_media": {
        "alt_text": "Luxury swimming pool and lounge area with lounge chairs and umbrellas.",
        "public_id": "019f6c0c-cdc5-748e-bcc4-8b95b0a87465",
        "storage_key": "property/5656427712479232/019f6c0c-cdc5-748e-bcc4-8b95b0a87465.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f6c0c-d8cc-72e9-adc3-16515fbf8c01.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a modern apartment building with a clear sky.",
        "public_id": "019f6c0c-d8cc-72e9-adc3-16515fbf8c01",
        "storage_key": "property/5656427712479232/019f6c0c-d8cc-72e9-adc3-16515fbf8c01.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Cadence at Cates Creek | Apartments For Rent Near Me with 1, 2 & 3 Bedroom Floor Plans",
      "seo_description": "Discover luxury apartments for rent near me with 1, 2 & 3 bedroom floor plans at Cadence at Cates Creek in Hillsborough, NC. Enjoy modern amenities and prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-walk-in-closets",
      "search_query": "Apartments For Rent Near Me with Walk-In Closets",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Walk-In Closets",
      "h2_subtitle": "Experience luxury living at Cadence at Cates Creek. Our apartments offer modern amenities and walk-in closets in Hillsborough, NC.",
      "page_copy": "Settle into a life of comfort, convenience, and luxury at Cadence at Cates Creek. Our apartments for rent near me with walk-in closets feature upscale interiors with wood-style flooring, crown molding, and private patios or Juliette balconies. Enjoy modern kitchens with stainless-steel-style appliances, granite countertops, and designer cabinetry. Located near UNC Medical Center, our community offers easy access to downtown shops, restaurants, and the Hillsborough Riverwalk. With amenities like walk-in closets, a resort style saltwater pool, and pet-friendly homes, Cadence at Cates Creek is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f6c0c-cdc5-748e-bcc4-8b95b0a87465.webp",
      "featured_image_media": {
        "alt_text": "Luxury swimming pool and lounge area with lounge chairs and umbrellas.",
        "public_id": "019f6c0c-cdc5-748e-bcc4-8b95b0a87465",
        "storage_key": "property/5656427712479232/019f6c0c-cdc5-748e-bcc4-8b95b0a87465.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f6c0c-d8cc-72e9-adc3-16515fbf8c01.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a modern apartment building with a clear sky.",
        "public_id": "019f6c0c-d8cc-72e9-adc3-16515fbf8c01",
        "storage_key": "property/5656427712479232/019f6c0c-d8cc-72e9-adc3-16515fbf8c01.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Cadence at Cates Creek | Apartments For Rent Near Me with Walk-In Closets",
      "seo_description": "Discover luxury apartments for rent near me with walk-in closets at Cadence at Cates Creek in Hillsborough, NC. Enjoy modern amenities and prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-modern-kitchens",
      "search_query": "Apartments For Rent Near Me with Modern Kitchens",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Modern Kitchens",
      "h2_subtitle": "Discover luxury living at Cadence at Cates Creek. Our apartments offer modern amenities and modern kitchens in Hillsborough, NC.",
      "page_copy": "Settle into a life of comfort, convenience, and luxury at Cadence at Cates Creek. Our apartments for rent near me with modern kitchens feature upscale interiors with wood-style flooring, crown molding, and private patios or Juliette balconies. Enjoy modern kitchens with stainless-steel-style appliances, granite countertops, and designer cabinetry. Located near UNC Medical Center, our community offers easy access to downtown shops, restaurants, and the Hillsborough Riverwalk. With amenities like modern kitchens, a resort style saltwater pool, and pet-friendly homes, Cadence at Cates Creek is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f6c0c-cdc5-748e-bcc4-8b95b0a87465.webp",
      "featured_image_media": {
        "alt_text": "Luxury swimming pool and lounge area with lounge chairs and umbrellas.",
        "public_id": "019f6c0c-cdc5-748e-bcc4-8b95b0a87465",
        "storage_key": "property/5656427712479232/019f6c0c-cdc5-748e-bcc4-8b95b0a87465.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f6c0c-d8cc-72e9-adc3-16515fbf8c01.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a modern apartment building with a clear sky.",
        "public_id": "019f6c0c-d8cc-72e9-adc3-16515fbf8c01",
        "storage_key": "property/5656427712479232/019f6c0c-d8cc-72e9-adc3-16515fbf8c01.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Cadence at Cates Creek | Apartments For Rent Near Me with Modern Kitchens",
      "seo_description": "Discover luxury apartments for rent near me with modern kitchens at Cadence at Cates Creek in Hillsborough, NC. Enjoy modern amenities and prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-granite-countertops",
      "search_query": "Apartments For Rent Near Me with Granite Countertops",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Granite Countertops",
      "h2_subtitle": "Experience luxury living at Cadence at Cates Creek. Our apartments offer modern amenities and granite countertops in Hillsborough, NC.",
      "page_copy": "Settle into a life of comfort, convenience, and luxury at Cadence at Cates Creek. Our apartments for rent near me with granite countertops feature upscale interiors with wood-style flooring, crown molding, and private patios or Juliette balconies. Enjoy modern kitchens with stainless-steel-style appliances, granite countertops, and designer cabinetry. Located near UNC Medical Center, our community offers easy access to downtown shops, restaurants, and the Hillsborough Riverwalk. With amenities like granite countertops, a resort style saltwater pool, and pet-friendly homes, Cadence at Cates Creek is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f6c0c-cdc5-748e-bcc4-8b95b0a87465.webp",
      "featured_image_media": {
        "alt_text": "Luxury swimming pool and lounge area with lounge chairs and umbrellas.",
        "public_id": "019f6c0c-cdc5-748e-bcc4-8b95b0a87465",
        "storage_key": "property/5656427712479232/019f6c0c-cdc5-748e-bcc4-8b95b0a87465.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f6c0c-d8cc-72e9-adc3-16515fbf8c01.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a modern apartment building with a clear sky.",
        "public_id": "019f6c0c-d8cc-72e9-adc3-16515fbf8c01",
        "storage_key": "property/5656427712479232/019f6c0c-d8cc-72e9-adc3-16515fbf8c01.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Cadence at Cates Creek | Apartments For Rent Near Me with Granite Countertops",
      "seo_description": "Discover luxury apartments for rent near me with granite countertops at Cadence at Cates Creek in Hillsborough, NC. Enjoy modern amenities and prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-stainless-steel-appliances",
      "search_query": "Apartments For Rent Near Me with Stainless-Steel-Style Appliances",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Stainless-Steel-Style Appliances",
      "h2_subtitle": "Discover luxury living at Cadence at Cates Creek. Our apartments offer modern amenities and stainless-steel-style appliances in Hillsborough, NC.",
      "page_copy": "Settle into a life of comfort, convenience, and luxury at Cadence at Cates Creek. Our apartments for rent near me with stainless-steel-style appliances feature upscale interiors with wood-style flooring, crown molding, and private patios or Juliette balconies. Enjoy modern kitchens with stainless-steel-style appliances, granite countertops, and designer cabinetry. Located near UNC Medical Center, our community offers easy access to downtown shops, restaurants, and the Hillsborough Riverwalk. With amenities like stainless-steel-style appliances, a resort style saltwater pool, and pet-friendly homes, Cadence at Cates Creek is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f6c0c-cdc5-748e-bcc4-8b95b0a87465.webp",
      "featured_image_media": {
        "alt_text": "Luxury swimming pool and lounge area with lounge chairs and umbrellas.",
        "public_id": "019f6c0c-cdc5-748e-bcc4-8b95b0a87465",
        "storage_key": "property/5656427712479232/019f6c0c-cdc5-748e-bcc4-8b95b0a87465.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f6c0c-d8cc-72e9-adc3-16515fbf8c01.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a modern apartment building with a clear sky.",
        "public_id": "019f6c0c-d8cc-72e9-adc3-16515fbf8c01",
        "storage_key": "property/5656427712479232/019f6c0c-d8cc-72e9-adc3-16515fbf8c01.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Cadence at Cates Creek | Apartments For Rent Near Me with Stainless-Steel-Style Appliances",
      "seo_description": "Discover luxury apartments for rent near me with stainless-steel-style appliances at Cadence at Cates Creek in Hillsborough, NC. Enjoy modern amenities and prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "custom",
      "page_item_url": "apartments-for-rent-hillsborough-nc-near-duke-university",
      "search_query": "Apartments For Rent In Hillsborough NC Near Duke University Hospital",
      "category": "POI",
      "h1_title": "Apartments For Rent In Hillsborough NC Near Duke University Hospital",
      "h2_subtitle": "Experience luxury living at Cadence at Cates Creek. Our apartments offer modern amenities and are conveniently located near Duke University Hospital.",
      "page_copy": "Settle into a life of comfort, convenience, and luxury at Cadence at Cates Creek. Our apartments for rent in Hillsborough, NC, near Duke University Hospital feature upscale interiors with wood-style flooring, crown molding, and private patios or Juliette balconies. Enjoy modern kitchens with stainless-steel-style appliances, granite countertops, and designer cabinetry. Located near UNC Medical Center and a short drive from Duke University Hospital, our community offers easy access to downtown shops, restaurants, and the Hillsborough Riverwalk. With amenities like a resort style saltwater pool, 24-hour fitness center, and pet-friendly homes, Cadence at Cates Creek is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f6c0c-cdc5-748e-bcc4-8b95b0a87465.webp",
      "featured_image_media": {
        "alt_text": "Luxury swimming pool and lounge area with lounge chairs and umbrellas.",
        "public_id": "019f6c0c-cdc5-748e-bcc4-8b95b0a87465",
        "storage_key": "property/5656427712479232/019f6c0c-cdc5-748e-bcc4-8b95b0a87465.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f6c0c-d8cc-72e9-adc3-16515fbf8c01.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a modern apartment building with a clear sky.",
        "public_id": "019f6c0c-d8cc-72e9-adc3-16515fbf8c01",
        "storage_key": "property/5656427712479232/019f6c0c-d8cc-72e9-adc3-16515fbf8c01.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Cadence at Cates Creek | Apartments For Rent In Hillsborough NC Near Duke University Hospital",
      "seo_description": "Discover luxury apartments for rent in Hillsborough, NC, near Duke University Hospital at Cadence at Cates Creek. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "custom",
      "page_item_url": "apartments-for-rent-in-hillsborough-nc-near-duke-childrens-hospital",
      "search_query": "Apartments For Rent In Hillsborough NC Near Duke Children's Hospital & Health Center",
      "category": "POI",
      "h1_title": "Apartments For Rent In Hillsborough NC Near Duke Children's Hospital & Health Center",
      "h2_subtitle": "Experience luxury living at Cadence at Cates Creek. Our apartments offer modern amenities and are conveniently located near Duke Children's Hospital & Health Center.",
      "page_copy": "Settle into a life of comfort, convenience, and luxury at Cadence at Cates Creek. Our apartments for rent in Hillsborough, NC, near Duke Children's Hospital & Health Center feature upscale interiors with wood-style flooring, crown molding, and private patios or Juliette balconies. Enjoy modern kitchens with stainless-steel-style appliances, granite countertops, and designer cabinetry. Located near UNC Medical Center and a short drive from Duke Children's Hospital & Health Center, our community offers easy access to downtown shops, restaurants, and the Hillsborough Riverwalk. With amenities like a resort style saltwater pool, 24-hour fitness center, and pet-friendly homes, Cadence at Cates Creek is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f6c0c-cdc5-748e-bcc4-8b95b0a87465.webp",
      "featured_image_media": {
        "alt_text": "Luxury swimming pool and lounge area with lounge chairs and umbrellas.",
        "public_id": "019f6c0c-cdc5-748e-bcc4-8b95b0a87465",
        "storage_key": "property/5656427712479232/019f6c0c-cdc5-748e-bcc4-8b95b0a87465.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f6c0c-d8cc-72e9-adc3-16515fbf8c01.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a modern apartment building with a clear sky.",
        "public_id": "019f6c0c-d8cc-72e9-adc3-16515fbf8c01",
        "storage_key": "property/5656427712479232/019f6c0c-d8cc-72e9-adc3-16515fbf8c01.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Cadence at Cates Creek | Apartments For Rent In Hillsborough NC Near Duke Children's Hospital & Health Center",
      "seo_description": "Discover luxury apartments for rent in Hillsborough, NC, near Duke Children's Hospital & Health Center at Cadence at Cates Creek. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "custom",
      "page_item_url": "apartments-for-rent-in-hillsborough-nc-near-fayhee-heather",
      "search_query": "Apartments For Rent In Hillsborough NC Near Fayhee Heather M",
      "category": "POI",
      "h1_title": "Apartments For Rent In Hillsborough NC Near Fayhee Heather M",
      "h2_subtitle": "Discover luxury living at Cadence at Cates Creek. Our apartments offer modern amenities and are conveniently located near Fayhee Heather M in Hillsborough, NC.",
      "page_copy": "Settle into a life of comfort, convenience, and luxury at Cadence at Cates Creek. Our apartments for rent in Hillsborough, NC, near Fayhee Heather M feature upscale interiors with wood-style flooring, crown molding, and private patios or Juliette balconies. Enjoy modern kitchens with stainless-steel-style appliances, granite countertops, and designer cabinetry. Located near UNC Medical Center and a short drive from Fayhee Heather M, our community offers easy access to downtown shops, restaurants, and the Hillsborough Riverwalk. With amenities like a resort style saltwater pool, 24-hour fitness center, and pet-friendly homes, Cadence at Cates Creek is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f6c0c-cdc5-748e-bcc4-8b95b0a87465.webp",
      "featured_image_media": {
        "alt_text": "Luxury swimming pool and lounge area with lounge chairs and umbrellas.",
        "public_id": "019f6c0c-cdc5-748e-bcc4-8b95b0a87465",
        "storage_key": "property/5656427712479232/019f6c0c-cdc5-748e-bcc4-8b95b0a87465.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f6c0c-d8cc-72e9-adc3-16515fbf8c01.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a modern apartment building with a clear sky.",
        "public_id": "019f6c0c-d8cc-72e9-adc3-16515fbf8c01",
        "storage_key": "property/5656427712479232/019f6c0c-d8cc-72e9-adc3-16515fbf8c01.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Cadence at Cates Creek | Apartments For Rent In Hillsborough NC Near Fayhee Heather M",
      "seo_description": "Discover luxury apartments for rent in Hillsborough, NC, near Fayhee Heather M at Cadence at Cates Creek. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "custom",
      "page_item_url": "apartments-for-rent-hillsborough-nc-near-unc-hospitals",
      "search_query": "Apartments For Rent In Hillsborough NC Near UNC Hospitals Urology Services Hillsborough",
      "category": "POI",
      "h1_title": "Apartments For Rent In Hillsborough NC Near UNC Hospitals Urology Services Hillsborough",
      "h2_subtitle": "Experience luxury living at Cadence at Cates Creek. Our apartments offer modern amenities and are conveniently located near UNC Hospitals Urology Services Hillsborough.",
      "page_copy": "Settle into a life of comfort, convenience, and luxury at Cadence at Cates Creek. Our apartments for rent in Hillsborough, NC, near UNC Hospitals Urology Services Hillsborough feature upscale interiors with wood-style flooring, crown molding, and private patios or Juliette balconies. Enjoy modern kitchens with stainless-steel-style appliances, granite countertops, and designer cabinetry. Located near UNC Medical Center and a short drive from UNC Hospitals Urology Services Hillsborough, our community offers easy access to downtown shops, restaurants, and the Hillsborough Riverwalk. With amenities like a resort style saltwater pool, 24-hour fitness center, and pet-friendly homes, Cadence at Cates Creek is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f6c0c-cdc5-748e-bcc4-8b95b0a87465.webp",
      "featured_image_media": {
        "alt_text": "Luxury swimming pool and lounge area with lounge chairs and umbrellas.",
        "public_id": "019f6c0c-cdc5-748e-bcc4-8b95b0a87465",
        "storage_key": "property/5656427712479232/019f6c0c-cdc5-748e-bcc4-8b95b0a87465.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f6c0c-d8cc-72e9-adc3-16515fbf8c01.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a modern apartment building with a clear sky.",
        "public_id": "019f6c0c-d8cc-72e9-adc3-16515fbf8c01",
        "storage_key": "property/5656427712479232/019f6c0c-d8cc-72e9-adc3-16515fbf8c01.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Cadence at Cates Creek | Apartments For Rent In Hillsborough NC Near UNC Hospitals Urology Services Hillsborough",
      "seo_description": "Discover luxury apartments for rent in Hillsborough, NC, near UNC Hospitals Urology Services Hillsborough at Cadence at Cates Creek. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "custom",
      "page_item_url": "apartments-for-rent-hillsborough-nc-near-duke-clinic",
      "search_query": "Apartments For Rent In Hillsborough NC Near Duke Clinic",
      "category": "POI",
      "h1_title": "Apartments For Rent In Hillsborough NC Near Duke Clinic",
      "h2_subtitle": "Experience luxury living at Cadence at Cates Creek. Our apartments offer modern amenities and are conveniently located near Duke Clinic in Hillsborough, NC.",
      "page_copy": "Settle into a life of comfort, convenience, and luxury at Cadence at Cates Creek. Our apartments for rent in Hillsborough, NC, near Duke Clinic feature upscale interiors with wood-style flooring, crown molding, and private patios or Juliette balconies. Enjoy modern kitchens with stainless-steel-style appliances, granite countertops, and designer cabinetry. Located near UNC Medical Center and a short drive from Duke Clinic, our community offers easy access to downtown shops, restaurants, and the Hillsborough Riverwalk. With amenities like a resort style saltwater pool, 24-hour fitness center, and pet-friendly homes, Cadence at Cates Creek is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f6c0c-cdc5-748e-bcc4-8b95b0a87465.webp",
      "featured_image_media": {
        "alt_text": "Luxury swimming pool and lounge area with lounge chairs and umbrellas.",
        "public_id": "019f6c0c-cdc5-748e-bcc4-8b95b0a87465",
        "storage_key": "property/5656427712479232/019f6c0c-cdc5-748e-bcc4-8b95b0a87465.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f6c0c-d8cc-72e9-adc3-16515fbf8c01.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a modern apartment building with a clear sky.",
        "public_id": "019f6c0c-d8cc-72e9-adc3-16515fbf8c01",
        "storage_key": "property/5656427712479232/019f6c0c-d8cc-72e9-adc3-16515fbf8c01.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Cadence at Cates Creek | Apartments For Rent In Hillsborough NC Near Duke Clinic",
      "seo_description": "Discover luxury apartments for rent in Hillsborough, NC, near Duke Clinic at Cadence at Cates Creek. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "custom",
      "page_item_url": "apartments-for-rent-hillsborough-nc-near-unc",
      "search_query": "Apartments For Rent In Hillsborough NC Near University of North Carolina at Chapel Hill",
      "category": "POI",
      "h1_title": "Apartments For Rent In Hillsborough NC Near University of North Carolina at Chapel Hill",
      "h2_subtitle": "Experience luxury living at Cadence at Cates Creek. Our apartments offer modern amenities and are conveniently located near the University of North Carolina at Chapel Hill.",
      "page_copy": "Settle into a life of comfort, convenience, and luxury at Cadence at Cates Creek. Our apartments for rent in Hillsborough, NC, near the University of North Carolina at Chapel Hill feature upscale interiors with wood-style flooring, crown molding, and private patios or Juliette balconies. Enjoy modern kitchens with stainless-steel-style appliances, granite countertops, and designer cabinetry. Located near UNC Medical Center and a short drive from the University of North Carolina at Chapel Hill, our community offers easy access to downtown shops, restaurants, and the Hillsborough Riverwalk. With amenities like a resort style saltwater pool, 24-hour fitness center, and pet-friendly homes, Cadence at Cates Creek is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f6c0c-cdc5-748e-bcc4-8b95b0a87465.webp",
      "featured_image_media": {
        "alt_text": "Luxury swimming pool and lounge area with lounge chairs and umbrellas.",
        "public_id": "019f6c0c-cdc5-748e-bcc4-8b95b0a87465",
        "storage_key": "property/5656427712479232/019f6c0c-cdc5-748e-bcc4-8b95b0a87465.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f6c0c-d8cc-72e9-adc3-16515fbf8c01.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a modern apartment building with a clear sky.",
        "public_id": "019f6c0c-d8cc-72e9-adc3-16515fbf8c01",
        "storage_key": "property/5656427712479232/019f6c0c-d8cc-72e9-adc3-16515fbf8c01.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Cadence at Cates Creek | Apartments For Rent In Hillsborough NC Near University of North Carolina at Chapel Hill",
      "seo_description": "Discover luxury apartments for rent in Hillsborough, NC, near the University of North Carolina at Chapel Hill at Cadence at Cates Creek. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656427712479232",
      "source": "custom",
      "page_item_url": "apartments-for-rent-hillsborough-nc-near-durham-tech",
      "search_query": "Apartments For Rent In Hillsborough NC Near Durham Technical Community College",
      "category": "POI",
      "h1_title": "Apartments For Rent In Hillsborough NC Near Durham Technical Community College",
      "h2_subtitle": "Experience luxury living at Cadence at Cates Creek. Our apartments offer modern amenities and are conveniently located near Durham Technical Community College.",
      "page_copy": "Settle into a life of comfort, convenience, and luxury at Cadence at Cates Creek. Our apartments for rent in Hillsborough, NC, near Durham Technical Community College feature upscale interiors with wood-style flooring, crown molding, and private patios or Juliette balconies. Enjoy modern kitchens with stainless-steel-style appliances, granite countertops, and designer cabinetry. Located near UNC Medical Center and a short drive from Durham Technical Community College, our community offers easy access to downtown shops, restaurants, and the Hillsborough Riverwalk. With amenities like a resort style saltwater pool, 24-hour fitness center, and pet-friendly homes, Cadence at Cates Creek is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f6c0c-cdc5-748e-bcc4-8b95b0a87465.webp",
      "featured_image_media": {
        "alt_text": "Luxury swimming pool and lounge area with lounge chairs and umbrellas.",
        "public_id": "019f6c0c-cdc5-748e-bcc4-8b95b0a87465",
        "storage_key": "property/5656427712479232/019f6c0c-cdc5-748e-bcc4-8b95b0a87465.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f6c0c-d8cc-72e9-adc3-16515fbf8c01.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a modern apartment building with a clear sky.",
        "public_id": "019f6c0c-d8cc-72e9-adc3-16515fbf8c01",
        "storage_key": "property/5656427712479232/019f6c0c-d8cc-72e9-adc3-16515fbf8c01.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Cadence at Cates Creek | Apartments For Rent In Hillsborough NC Near Durham Technical Community College",
      "seo_description": "Discover luxury apartments for rent in Hillsborough, NC, near Durham Technical Community College at Cadence at Cates Creek. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "2146"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "2486464701"
    },
    {
      "ID": "custom_leasing_ai",
      "type": "STRING",
      "value": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a1b\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a1b\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4939303"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-MWQWBZW"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "1"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "8443932493"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "e511f154aa1338d2"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/dqw9e1ogpo9"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/21c2b3d4-1270-42e6-8a4d-046546089ccf"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "984-360-9856"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImlDZlZOMEJndktYZ2s4N2dTNkZFc2c9PSIsInZhbHVlIjoiSTJoN1hiK0dkTG1oRERQU2RKY09Rdz09IiwibWFjIjoiNWVmZDM3M2E0ZmRhNjcxZTYyZDk2ZWIzZjMyODE5NWU0MmZlMTQxYmVhNGViYjY3Y2QyMDY2YjNiNGJhMWVjYSJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "2146",
  "custom_repli_id": "2486464701",
  "custom_leasing_ai": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a1b\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a1b\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />",
  "custom_realpage_id": "4939303",
  "custom_google_gtm_id": "GTM-MWQWBZW",
  "custom_rollout_phase": "1",
  "custom_ads_subscription": "full_stack",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "8443932493",
  "custom_knock_community_id": "e511f154aa1338d2",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/dqw9e1ogpo9",
  "custom_self_guided_tour_url": "https://selftournow.com/property/21c2b3d4-1270-42e6-8a4d-046546089ccf",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "984-360-9856",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImlDZlZOMEJndktYZ2s4N2dTNkZFc2c9PSIsInZhbHVlIjoiSTJoN1hiK0dkTG1oRERQU2RKY09Rdz09IiwibWFjIjoiNWVmZDM3M2E0ZmRhNjcxZTYyZDk2ZWIzZjMyODE5NWU0MmZlMTQxYmVhNGViYjY3Y2QyMDY2YjNiNGJhMWVjYSJ9",
  "custom_household_income_qualification_multiplier": "3",
  "custom_audioeye_site_id": "ec060f6d-cde3-409d-8f17-3825218d37f3",
  "custom_audioeye_site_hash": "f449dda1bfd60b04f4d5a19e5b647730"
};

export const generatedAt = '2026-11-03T20:38:39.943Z';
